<template>
  <svg
  class=""
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 901.835 675.804"
  >
    <defs>
      <linearGradient
        id="a"
        x1=".5"
        y1="1"
        x2=".5"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stop-color="gray" stop-opacity=".251" />
        <stop offset=".54" stop-color="gray" stop-opacity=".122" />
        <stop offset="1" stop-color="gray" stop-opacity=".102" />
      </linearGradient>
      <linearGradient id="b" x1=".5" y1="1" x2=".5" y2="0" xlink:href="#a" />
    </defs>
    <g data-name="Group 569">
      <g transform="translate(-49.271 -.003)">
        <path
          data-name="Path 848"
          d="M51.001 278.975h83.709v114.106H57.124c-.2 1.18-.4 2.351-.619 3.531h78.207v92.003a1.177 1.177 0 01-.388-.148q-3.3-1.311-6.6-2.78c-.47-.215-.932-.437-1.411-.643q-3.3-1.559-6.6-3.3a68.38 68.38 0 01-2.285-1.254 137.29 137.29 0 01-32.913-25.621c-.289-.272-.553-.569-.825-.825a142.053 142.053 0 01-3.918-4.421c-.478-.553-.94-1.114-1.411-1.65a136.993 136.993 0 01-4.355-5.634c-.214-.289-.412-.569-.619-.825a121.85 121.85 0 01-14.186-25.65c-.115-.272-.223-.569-.33-.825a109.037 109.037 0 01-3.06-8.8c-.379-1.246-.751-2.475-1.064-3.77-.115-.371-.206-.751-.305-1.122-4.636-18.271-5.172-37.26-5.172-56.158v-6.6q.1-11.573.272-23.121.066-2.97.124-5.964.173-7.581.495-15.194c.049-1.4.115-2.813.19-4.207q.049-1.213.124-2.425.226-4.381.526-8.703z"
          fill="#07677e;"
          opacity=".1"
        />
        <path
          data-name="Path 849"
          d="M134.711 151.927h-45.92a349.549 349.549 0 0124.42-33.606 428.337 428.337 0 0121.5-24.416z"
          fill="#07677e;"
          opacity=".1"
        />
        <path
          data-name="Path 850"
          d="M134.712 155.441v120H51.267c0-.346.049-.7.083-1.048.074-.949.148-1.889.231-2.838.082-1.105.19-2.211.3-3.3s.214-2.409.346-3.6.239-2.409.371-3.6.264-2.392.412-3.58.28-2.392.445-3.58c.124-.982.247-1.971.388-2.961.19-1.394.388-2.788.594-4.174a3.969 3.969 0 01.1-.627 287.825 287.825 0 016.137-30.125 223.05 223.05 0 0110.352-30.521 229.208 229.208 0 0115.571-30.046z"
          fill="#07677e;"
          opacity=".1"
        />
        <path
          data-name="Path 851"
          d="M154.707 278.975v114.106h178.8V278.975zm0 117.636v98c1.023.206 2.029.412 3.044.586 1.361.264 2.73.5 4.124.709l.825.115c.544.091 1.1.165 1.65.231 1.378.2 2.755.346 4.124.478.643.066 1.312.115 1.963.173l1.592.115c.866.066 1.724.115 2.582.148.528 0 1.056.041 1.592.058s.825 0 1.254 0h4.586c.709 0 1.419 0 2.12-.066h.041a12.613 12.613 0 001.477-.058 3.609 3.609 0 00.421 0 9.948 9.948 0 001.221-.049 1.735 1.735 0 01.28 0c.916-.058 1.84-.132 2.772-.214s1.815-.181 2.747-.28l1.872-.231a164.264 164.264 0 0022.643-4.817c16.687-4.652 33-11.161 49.674-15.92 21.546-6.145 45.368-9.173 66.188-1.691v-77.286zm178.8-244.684V.017a229.754 229.754 0 00-58.09 6.805c-45.275 11.375-85.933 36.048-120.71 67.558v77.539h9v3.521h-9v120h178.8v-120h-132.99v-3.53zm229.71-51.316c-11.2-.4-22.338-3.935-32.418-9.42-19.253-10.468-34.645-26.652-51.836-40.3-35.717-28.434-80.014-45.6-125.456-49.856v150.892h255.231l.635-.668zm23.253-4.124l24.656 27.064V89.368c-8.3 1.048-15.524 3.481-24.656 7.086zm24.66 422.453V396.612h-52.578a31.236 31.236 0 00-.445-1.576c.157.528.3 1.056.437 1.576H353.512v88.46c1.947 1.444 3.869 2.97 5.774 4.5q3.085 2.524 6.129 5.106l2.046 1.691c.982.825 1.98 1.65 2.97 2.433q2.978 2.4 6 4.751 1.51 1.188 3.036 2.334a414.143 414.143 0 0050.841 33.253 421.07 421.07 0 0012.035 6.442q4.034 2.079 8.125 4.075 6.137 2.994 12.373 5.774a454.177 454.177 0 00120.433 35.074q13.842 2.038 27.807 3.217v-74.8h.825zm-257.618-363.5v120H611.13v-120zm0 123.518v114.123H611.13V278.975zM631.125 89.203v38.192l31.461-34.538q-15.639-2.581-31.461-3.654zm0 189.772v114.106h250.558V278.975zM880.8 527.991l.883-131.379H631.125v198.441a451.469 451.469 0 0048.421-.586h.28q11.548-.742 22.989-2.112h.173a422.749 422.749 0 00118.148-31.56m108.881-263.078q-1.427-3.3-2.928-6.6c-1.864-4.124-3.828-8.133-5.857-12.134h-19.55v114.1h49.419c-.041-32.319-8.224-65.314-21.084-95.364zm-28.335 98.895V509.62c13.916-13.338 25.687-28.607 34.15-46.061 10.187-21.026 14.848-43.776 15.236-66.956zm0-150.887v29.7H919.4a322.627 322.627 0 00-17.718-29.7zM731.761 111.599c-1.3-.5-2.615-1.006-3.926-1.485a356.47 356.47 0 00-42.316-12.72l-48.157 52.846-.94 1.015.619.668h171.393a366.166 366.166 0 00-76.673-40.32zm81.704 43.841H634.639l-3.514 3.209V275.44h250.558v-56.582a356.76 356.76 0 00-68.218-63.418z"
          fill="#07677e;"
          opacity=".1"
        />
        <path
          data-name="Path 852"
          d="M134.712 215.979v59.466H51.267c0-.346.049-.7.083-1.048.074-.949.148-1.889.231-2.838.082-1.105.19-2.211.3-3.3s.214-2.409.346-3.6.239-2.409.371-3.6.264-2.392.412-3.58.28-2.392.445-3.58c.124-.982.247-1.972.388-2.961.19-1.394.388-2.788.594-4.174a3.969 3.969 0 01.1-.627 287.825 287.825 0 016.137-30.125z"
          fill="#07677e;"
          opacity=".1"
        />
        <path
          data-name="Path 853"
          d="M51.001 278.975h83.709v114.106H57.124c-.2 1.18-.4 2.351-.619 3.531h78.207v92.003a1.177 1.177 0 01-.388-.148q-3.3-1.311-6.6-2.78c-.47-.215-.932-.437-1.411-.643q-3.3-1.559-6.6-3.3a68.38 68.38 0 01-2.285-1.254 137.29 137.29 0 01-32.913-25.621c-.289-.272-.553-.569-.825-.825a142.053 142.053 0 01-3.918-4.421c-.478-.553-.94-1.114-1.411-1.65a136.993 136.993 0 01-4.355-5.634c-.214-.289-.412-.569-.619-.825a121.85 121.85 0 01-14.186-25.65c-.115-.272-.223-.569-.33-.825a109.037 109.037 0 01-3.06-8.8c-.379-1.246-.751-2.475-1.064-3.77-.115-.371-.206-.751-.305-1.122-4.636-18.271-5.172-37.26-5.172-56.158v-6.6q.1-11.573.272-23.121.066-2.97.124-5.964.173-7.581.495-15.194c.049-1.4.115-2.813.19-4.207q.049-1.213.124-2.425.226-4.381.526-8.703z"
          fill="#07677e;"
          opacity=".1"
        />
        <path
          data-name="Path 854"
          d="M217.646 172.632v102.81h-62.947v-102.81h8.97v-34.81h36.839v34.81z"
          fill="#07677e"
          opacity=".1"
        />
        <path
          data-name="Rectangle 149"
          fill="#07677e"
          opacity=".1"
          d="M154.699 278.967h62.938v114.106h-62.938z"
        />
        <path
          data-name="Path 855"
          d="M154.707 396.612h62.938v94.861a163.013 163.013 0 01-22.643 4.809c-.627.091-1.246.165-1.872.231-.924.107-1.839.206-2.755.289l-2.763.223h-.28l-1.221.066h-.421c-.495 0-.982.058-1.477.066h-.041c-.709 0-1.411.05-2.12.066h-5.84a12.971 12.971 0 01-1.6-.066q-1.27-.049-2.574-.148l-1.592-.115c-.66-.05-1.32-.115-1.971-.182q-2.079-.181-4.124-.47l-1.65-.231-.825-.115a103.49 103.49 0 01-4.124-.7 100.396 100.396 0 01-3.044-.6z"
          fill="#07677e"
          opacity=".1"
        />
        <path
          data-name="Rectangle 150"
          fill="#07677e"
          opacity=".1"
          d="M559.221 160.489h51.902v114.947h-51.902z"
        />
        <path
          data-name="Path 856"
          d="M611.131 278.967v114.11H353.512V343.86h137.219v29.036h68.49v-93.929z"
          fill="#07677e"
          opacity=".1"
        />
        <path
          data-name="Path 857"
          d="M611.947 518.966a4.656 4.656 0 01-.825-.05v74.86q-13.949-1.147-27.8-3.209a454.781 454.781 0 01-120.48-35.059q-16.6-7.49-32.533-16.324a415.688 415.688 0 01-50.837-33.251q-6.088-4.652-11.994-9.511c-2.73-2.26-5.436-4.57-8.191-6.805-1.9-1.542-3.819-3.069-5.774-4.52v-88.485h205.031c-.148-.528-.281-1.048-.429-1.576.157.528.305 1.048.437 1.576h52.578v122.3c.273.005.545.029.817.054z"
          fill="#07677e"
          opacity=".1"
        />
        <path
          data-name="Path 858"
          d="M746.493 151.927h-33.82v-10.509h15.153v-31.3q1.971.726 3.926 1.485v29.819h14.732z"
          fill="#07677e"
          opacity=".1"
        />
        <path
          data-name="Path 859"
          d="M827.984 275.441H661.935a.108.108 0 00.05 0h-30.859V160.498h8.727v84.963h39.875v-50.32h32.954v-39.7h33.82v39.726h32.938v50.318h48.552z"
          fill="#07677e"
          opacity=".1"
        />
        <path
          data-name="Path 860"
          d="M631.126 283.232v114.106h196.866V283.232zm250.277 248.413l.281-90.325h-53.692v-40.419H631.126V599.31a451.5 451.5 0 0048.421-.586h.281q11.548-.742 22.989-2.112h.173a422.749 422.749 0 00118.148-31.56"
          fill="#07677e"
          opacity=".1"
        />
        <path
          data-name="Path 861"
          d="M905.152 396.612h45.921c-.4 23.171-5.048 45.929-15.236 66.948-8.463 17.463-20.234 32.731-34.15 46.069v-72.587h3.464z"
          fill="#07677e"
          opacity=".1"
        />
        <path
          data-name="Path 862"
          d="M951.101 393.082h-45.95v-95.365h24.87c12.86 30.05 21.043 63.046 21.08 95.365z"
          fill="#07677e"
          opacity=".1"
        />
        <path
          data-name="Rectangle 151"
          fill="#07677e"
          opacity=".1"
          d="M583.324 192.445h27.807v36.039h-27.807z"
        />
        <path
          data-name="Rectangle 152"
          fill="#07677e"
          opacity=".1"
          d="M583.324 267.147h27.807v8.298h-27.807z"
        />
        <path
          data-name="Rectangle 153"
          fill="#07677e"
          opacity=".1"
          d="M583.324 278.967h27.807v24.21h-27.807z"
        />
        <path
          data-name="Rectangle 154"
          fill="#07677e"
          opacity=".1"
          d="M583.324 341.848h27.807v36.039h-27.807z"
        />
        <path
          data-name="Rectangle 155"
          fill="#07677e"
          opacity=".1"
          d="M583.324 416.549h27.807v36.039h-27.807z"
        />
        <path
          data-name="Path 863"
          d="M611.131 518.908a4.008 4.008 0 01.825.058 4.669 4.669 0 01-.825-.049v8.373h-27.807v-36.04h27.807z"
          fill="#07677e"
          opacity=".1"
        />
        <path
          data-name="Path 864"
          d="M611.131 565.943v27.832q-13.957-1.147-27.807-3.209v-24.623z"
          fill="#07677e"
          opacity=".1"
        />
        <path
          data-name="Rectangle 156"
          fill="#FFEE00"
          opacity=".1"
          d="M353.512 390.433h119.171v2.648H353.512z"
        />
        <path
          data-name="Rectangle 157"
          fill="#07677e"
          opacity=".1"
          d="M353.512 396.603h119.171v10.146H353.512z"
        />
        <path
          data-name="Rectangle 158"
          fill="#07677e"
          opacity=".1"
          d="M353.512 440.009h119.171v16.316H353.512z"
        />
        <path
          data-name="Path 865"
          d="M472.686 489.584v16.32h-93.215q-6.088-4.636-11.994-9.519c-2.739-2.252-5.444-4.562-8.191-6.8z"
          fill="#07677e"
          opacity=".1"
        />
        <path
          data-name="Path 866"
          d="M472.682 539.151v16.357h-9.841q-16.6-7.49-32.533-16.324z"
          fill="#07677e"
          opacity=".1"
        />
        <path
          data-name="Rectangle 159"
          fill="#FFEE00"
          opacity=".1"
          d="M679.546 290.029h23.46v23.46h-23.46z"
        />
        <path
          data-name="Rectangle 160"
          fill="#07677e"
          opacity=".1"
          d="M171.601 180.724h23.46v23.46h-23.46z"
        />
        <path
          data-name="Rectangle 161"
          fill="#07677e"
          opacity=".1"
          d="M171.601 235.215h23.46v23.46h-23.46z"
        />
        <path
          data-name="Rectangle 162"
          fill="#07677e"
          opacity=".1"
          d="M171.601 289.707h23.46v23.46h-23.46z"
        />
        <path
          data-name="Rectangle 163"
          fill="#07677e"
          opacity=".1"
          d="M171.601 344.19h23.46v23.46h-23.46z"
        />
        <path
          data-name="Rectangle 164"
          fill="#07677e"
          opacity=".1"
          d="M171.601 398.682h23.46v23.46h-23.46z"
        />
        <path
          data-name="Rectangle 165"
          fill="#07677e"
          opacity=".1"
          d="M171.601 453.174h23.46v23.46h-23.46z"
        />
        <path
          data-name="Rectangle 166"
          fill="#07677e"
          opacity=".1"
          d="M769.103 290.029h23.46v23.46h-23.46z"
        />
        <path
          data-name="Rectangle 167"
          fill="#FFEE00"
          opacity=".1"
          d="M679.546 347.894h23.46v23.46h-23.46z"
        />
        <path
          data-name="Rectangle 168"
          fill="#07677e"
          opacity=".1"
          d="M769.103 347.894h23.46v23.46h-23.46z"
        />
        <path
          data-name="Rectangle 169"
          fill="#FFEE00"
          opacity=".1"
          d="M679.546 405.751h23.46v23.46h-23.46z"
        />
        <path
          data-name="Rectangle 170"
          fill="#07677e"
          opacity=".1"
          d="M769.103 405.751h23.46v23.46h-23.46z"
        />
        <path
          data-name="Rectangle 171"
          fill="#FFEE00"
          opacity=".1"
          d="M679.546 463.617h23.46v23.46h-23.46z"
        />
        <path
          data-name="Rectangle 172"
          fill="#07677e"
          opacity=".1"
          d="M769.103 463.617h23.46v23.46h-23.46z"
        />
        <path
          data-name="Rectangle 173"
          fill="#FFEE00"
          opacity=".1"
          d="M679.546 521.482h23.46v23.46h-23.46z"
        />
        <path
          data-name="Rectangle 174"
          fill="#07677e"
          opacity=".1"
          d="M769.103 521.482h23.46v23.46h-23.46z"
        />
        <path
          data-name="Path 867"
          d="M679.546 594.467v-15.128h23.451v12.975z"
          fill="#FFEE00"
          opacity=".1"
        />
        <path
          data-name="Path 868"
          d="M54.435 246.104v13.421h80.277v-13.421zm7.993 12.579h-6.6v-11.729h6.6zm7.993 0h-6.6v-11.729h6.6zm7.977 0h-6.6v-11.729h6.6zm7.993 0h-6.6v-11.729h6.6zm7.985 0h-6.6v-11.729h6.6zm7.993 0h-6.6v-11.729h6.6zm7.993 0h-6.6v-11.729h6.6zm7.985 0h-6.6v-11.729h6.6zm7.985 0h-6.6v-11.729h6.6zm7.993 0h-6.6v-11.729h6.6z"
          fill="#07677e"
          opacity=".1"
        />
        <path
          data-name="Path 869"
          d="M54.435 285.17v13.421h80.277V285.17zm7.993 12.579h-6.6V286.02h6.6zm7.993 0h-6.6V286.02h6.6zm7.977 0h-6.6V286.02h6.6zm7.993 0h-6.6V286.02h6.6zm7.985 0h-6.6V286.02h6.6zm7.993 0h-6.6V286.02h6.6zm7.993 0h-6.6V286.02h6.6zm7.985 0h-6.6V286.02h6.6zm7.985 0h-6.6V286.02h6.6zm7.993 0h-6.6V286.02h6.6z"
          fill="#07677e"
          opacity=".1"
        />
        <path
          data-name="Path 870"
          d="M54.435 324.245v13.413h80.277v-13.413zm7.993 12.563h-6.6v-11.73h6.6zm7.993 0h-6.6v-11.73h6.6zm7.977 0h-6.6v-11.73h6.6zm7.993 0h-6.6v-11.73h6.6zm7.985 0h-6.6v-11.73h6.6zm7.993 0h-6.6v-11.73h6.6zm7.993 0h-6.6v-11.73h6.6zm7.985 0h-6.6v-11.73h6.6zm7.985 0h-6.6v-11.73h6.6zm7.993 0h-6.6v-11.73h6.6z"
          fill="#07677e"
          opacity=".1"
        />
        <path
          data-name="Path 871"
          d="M54.435 363.311v13.413h80.277v-13.413zm7.993 12.571h-6.6v-11.746h6.6zm7.993 0h-6.6v-11.746h6.6zm7.977 0h-6.6v-11.746h6.6zm7.993 0h-6.6v-11.746h6.6zm7.985 0h-6.6v-11.746h6.6zm7.993 0h-6.6v-11.746h6.6zm7.993 0h-6.6v-11.746h6.6zm7.985 0h-6.6v-11.746h6.6zm7.985 0h-6.6v-11.746h6.6zm7.993 0h-6.6v-11.746h6.6z"
          fill="#07677e"
          opacity=".1"
        />
        <path
          data-name="Path 872"
          d="M54.822 402.361c.313 1.27.685 2.524 1.064 3.77v-2.92h6.6v11.722h-3.539c.1.28.206.569.322.825h75.477v-13.4zm15.673 12.571h-6.6v-11.721h6.6zm7.977 0h-6.6v-11.721h6.6zm7.993 0h-6.6v-11.721h6.6zm7.985 0h-6.6v-11.721h6.6zm7.993 0h-6.6v-11.721h6.6zm7.993 0h-6.6v-11.721h6.6zm7.985 0h-6.599v-11.721h6.6zm7.985 0h-6.6v-11.721h6.6zm7.993 0h-6.6v-11.721h6.6z"
          fill="#07677e"
          opacity=".1"
        />
        <path
          data-name="Path 873"
          d="M73.415 441.427c.214.264.412.561.619.825h4.364v5.634l1.411 1.65v-7.317h6.6v11.829h-2.714c.264.272.52.561.825.825h50.175v-13.446zm21 12.621h-6.6v-11.78h6.6zm7.993 0h-6.6v-11.78h6.6zm7.993 0h-6.6v-11.78h6.6zm7.985 0h-6.6v-11.78h6.6zm7.985 0h-6.6v-11.78h6.6zm7.993 0h-6.6v-11.78h6.6z"
          fill="#07677e"
          opacity=".1"
        />
        <path
          data-name="Path 874"
          d="M117.456 480.494c.759.429 1.526.825 2.293 1.246v-.412h6.6v3.72c.478.206.932.429 1.4.643v-4.364h6.6v7.143a2.69 2.69 0 00.388.14v-8.116z"
          fill="#FFEE00"
          opacity=".1"
        />
        <path
          data-name="Path 875"
          d="M661.935 275.445zm-50.812 243.464zm-53.016-123.873c.157.528.3 1.056.437 1.576a23.102 23.102 0 00-.437-1.576zm103.828-119.591zM163.707 151.928v3.514h36.847v-3.531zm447.424 366.981zm-53.024-123.873c.157.528.3 1.056.437 1.576a23.102 23.102 0 00-.437-1.576zm103.828-119.591zm-50.812 243.464zm-53.016-123.873c.157.528.3 1.056.437 1.576a23.102 23.102 0 00-.437-1.576z"
          fill="#07677e"
          opacity=".1"
        />
        <circle
          data-name="Ellipse 59"
          cx="2.227"
          cy="2.227"
          r="2.227"
          transform="translate(704.342 339.654)"
          opacity=".1"
        />
        <circle
          data-name="Ellipse 61"
          cx="2.227"
          cy="2.227"
          r="2.227"
          transform="translate(708.442 436.066)"
          opacity=".1"
        />
        <circle
          data-name="Ellipse 63"
          cx="2.227"
          cy="2.227"
          r="2.227"
          transform="translate(706.569 387.86)"
          opacity=".1"
        />
      </g>
      <g data-name="Group 565" transform="translate(-20669.529 -6184.746)">
        <ellipse
          data-name="Ellipse 56"
          cx="71.289"
          cy="11.45"
          rx="71.289"
          ry="11.45"
          transform="translate(20700.301 6837.65)"
          fill="#07677e"
          opacity=".4"
        />
        <path
          data-name="Path 876"
          d="M521.468 393.4a.387.387 0 00-.11-.19c-1.09-1.075-14.991-20.734-14.991-20.734s-.732-2.195-1.917-5.048a5.017 5.017 0 00.841-1.646 5.649 5.649 0 00.139-.768c0-.08.059-.146.08-.227a5.553 5.553 0 00-.073-3.014 5.212 5.212 0 01-.3.732 12.231 12.231 0 00-1.1-2.444c-1.844-3.175-4.477-5.853-6.416-8.948a24.209 24.209 0 01-3.3-16.066v.863a25.042 25.042 0 01.439-3.292 22.843 22.843 0 011.226-3.618c1.741-3.987 4.558-7.462 6.27-11.464a21.727 21.727 0 001.3-4.192 23.484 23.484 0 00.651-7.353 11.706 11.706 0 01-.183 1.749 23.814 23.814 0 00-6.724-15.854c-5.977-6.007-14.559-8.34-22.768-9.57a20.858 20.858 0 01-9.584-3.658 16.661 16.661 0 00-10.916-2.085 18 18 0 00-11.113 5.494c-3.9 4.287-5.59 10.36-10.14 13.974-2.758 2.195-6.255 3.219-9.467 4.712s-6.248 3.658-7.28 6.863v.117l-.044.117c-1.068 3.79.995 7.645 2.07 11.428 1.119 3.914 1.193 8.048 1.251 12.094.08 4.946.154 9.9.073 14.852-.037 1.946-.1 3.914-.249 5.853a30.667 30.667 0 00-5.026 2.019c-1.639 1.068-7.77 7.689-7.77 7.689L394.35 407.6l.161.183-.161.622.607-.139a61.731 61.731 0 0012.24 10.286l.512 8.984s.615 9.014 8.9 12.737c.19 3.124.783 15.81-1.961 20.836a23.412 23.412 0 00-2.59 11.911s.958 7.623-.132 11.633a19.023 19.023 0 00-.139 8.165v2.407c0 8.114.1 34.115 0 37.056-.139 3.475 0 54.871 0 54.871s-.68 25.687-2.861 32.645-1.632 30-1.632 30-1.368 27.443 3.468 32.857c0 .241-.044.49-.051.732v.344c-.059 2.085.344 4.3 2.136 4.982 3.658 1.4 8.494 5.619 9.409 6.826s6.233 4.214 13.169 3.409a99.154 99.154 0 0113.089-.6s2.736-.5 1.851-3.9c-.571-2.122-2.707-5.385-4.229-7.528.278.073.549.132.8.183l.263.051h.2a2.814 2.814 0 00.337 0h.146a2.5 2.5 0 00.41 0c1.836-.176 8.684 3.014 9.906 5.121s5.531 3.709 8.779 4.112c1.931.234 6.8-.161 10.894-.688a40.112 40.112 0 006.1-1.112c.966-.366 1.171-1.536.893-2.853a7.425 7.425 0 00-2.531-4.273 20.548 20.548 0 01-3.907-4.873l-.307-.49c2.041-1.946 5.729-8.311 6.848-9.628 1.361-1.6-2.195-60.2-2.195-60.2v-29.375l5.451-27.8 3.812-14.713 3.27-22.212s5.721-25.943 3.958-28.489c0-.051-1.463-26.763-3-33.179-.666-2.861-.5-9.3-.1-15.561a3.073 3.073 0 00.732-3.2 6.654 6.654 0 00-.424-1.09v-.337a50.379 50.379 0 019.855-3.351c5.451-1.068 4.09-3.878 4.09-3.878s1.229-2.407 2.041-3.878.139-14.449 0-15.518c-.051-.432-.388-2.817-.776-5.524 1.749-1.244 4.024-2.787 6.5-4.251 4.736-2.798 3.675-5.746 3.287-6.513zm-71.113 185.485s-4.09 10.433-2.451 13.1-.271 12.584-.271 12.584l-1.368 14.713s-3.812 27.289-2.451 33.706c1.068 5.033 1.463 20.068 1.588 26.338a1.831 1.831 0 00-.271.132l-.183.1c.629-2.466.366-7.455-2.758-17.493l-.263-41.461s-.483-47.892 3.3-53.247 5.121-14.449 5.121-14.449-.819 13.118-1.353 16.593 1.36 9.384 1.36 9.384zm-7.616 103.055c-.037.088-.08.176-.11.256l-.2-.263a2.165 2.165 0 00.315.007z"
          transform="translate(20332.193 6152.944)"
          fill="url(#a)"
        />
        <path
          data-name="Path 877"
          d="M20816.641 6851.317c-2.114.812-13.579 2.195-16.783 1.807s-7.448-2.012-8.655-4.134-7.975-5.326-9.789-5.121a6.584 6.584 0 01-2.195-.307 27.013 27.013 0 01-3.658-1.4 6.79 6.79 0 01.081-2.78 4.455 4.455 0 01.161-.541 4.836 4.836 0 012.458-2.736l.263-.124a7.443 7.443 0 011.58-.483c5.75-1.1 29.477 1.112 29.477 1.112s.666 1.193 1.58 2.67a20.419 20.419 0 003.863 4.9 7.5 7.5 0 012.495 4.3c.278 1.295.073 2.478-.878 2.837z"
          fill="#fff"
        />
        <path
          data-name="Path 878"
          d="M20816.641 6851.317c-2.114.812-13.571 2.195-16.776 1.807s-7.448-2.019-8.662-4.134-7.967-5.326-9.782-5.121-5.853-1.712-5.853-1.712a6.065 6.065 0 011.2-4.924l3.658 2.6s9.789 3.036 11.6 5.853 5.121 4.39 9.9 4.675c3.57.234 11.772-1.156 15.613-1.851.258 1.263.06 2.448-.898 2.807z"
          opacity=".1"
        />
        <path
          data-name="Path 879"
          d="M20781.619 6855.048a97.4 97.4 0 00-12.92.607c-6.87.8-12.116-2.195-13.03-3.431a30.529 30.529 0 00-9.284-6.877c-1.778-.688-2.195-2.926-2.114-5.019v-.344a20.487 20.487 0 01.585-3.929l28.467-.607 2.466 3.344.38.512 1.5 2.041s.68.893 1.573 2.195c1.507 2.195 3.614 5.436 4.177 7.58.899 3.431-1.8 3.928-1.8 3.928z"
          fill="#fff"
        />
        <path
          data-name="Path 880"
          d="M20781.619 6855.048a97.389 97.389 0 00-12.92.607c-6.863.8-12.116-2.195-13.023-3.431a29.67 29.67 0 00-9.292-6.863c-1.778-.688-2.195-2.927-2.114-5.019 2.034.476 6.307 1.69 7.982 3.8 2.195 2.824 6.124 7.572 11.706 7.872 4.507.241 15.481-.563 19.5-.885.868 3.422-1.839 3.919-1.839 3.919z"
          opacity=".1"
        />
        <path
          data-name="Path 881"
          d="M20778.231 6836.07c-.329 2.444-1.346 3.1-2.078 3.248a1.412 1.412 0 01-.541 0 1.8 1.8 0 01-.285-.044s-25.563 5.648-30.728 1.075a3.581 3.581 0 01-.366-.38 20.488 20.488 0 01.585-3.929l28.467-.607 2.466 3.344a4.836 4.836 0 012.458-2.736z"
          opacity=".1"
        />
        <path
          data-name="Path 882"
          d="M20811.154 6839.245c-.571.629-1.046.988-1.346.863-1.346-.541-12.379-2.422-15.883-.8s-15.364.263-15.364.263 0-1.4-.066-3.658a7.443 7.443 0 011.58-.483c5.75-1.1 29.477 1.112 29.477 1.112s.695 1.225 1.602 2.703z"
          opacity=".1"
        />
        <path
          data-name="Path 883"
          d="M20827.849 6673.753l-3.234 22.344-3.76 14.808-5.385 27.991v29.63s3.5 58.954 2.151 60.563-6.46 10.777-7.806 10.243-12.379-2.422-15.883-.812-15.364.271-15.364.271-.271-22.878-1.617-29.338 2.422-33.918 2.422-33.918l1.346-14.8s1.888-9.965.271-12.657 2.422-13.169 2.422-13.169-1.88-5.933-1.339-9.431 1.339-16.688 1.339-16.688-1.339 9.16-5.077 14.537-3.263 53.569-3.263 53.569l.263 41.7c6.738 22.08 0 19.922 0 19.922s-25.563 5.655-30.728 1.075-3.687-33.406-3.687-33.406-.534-23.148 1.617-30.143 2.831-32.842 2.831-32.842-.139-51.689 0-55.178c.1-2.927 0-29.126 0-37.312v-2.422l3.087-7.667 36.581-4.58h17.5s26.338 6.19 29.06 8.86a.607.607 0 01.146.161c1.762 2.585-3.893 28.689-3.893 28.689z"
          fill="#07677e"
        />
        <path
          data-name="Path 884"
          d="M20783.434 6791.119s8.048 19.38 11.845 20.727-11.845-20.727-11.845-20.727z"
          opacity=".1"
        />
        <path
          data-name="Path 885"
          d="M20786.41 6819.652s27.172 1.346 26.9 4.309-26.9-4.309-26.9-4.309z"
          opacity=".1"
        />
        <path
          data-name="Path 886"
          d="M20750.056 6811.905c1.075 1.017 20.727 2.926 19.11 4.785s-17.493 5.472-17.493 5.472z"
          opacity=".1"
        />
        <path
          data-name="Path 887"
          d="M20746.83 6778.47c0 .8 4.039 25.841 5.121 26.916s9.957 2.151 9.957 2.151z"
          opacity=".1"
        />
        <path
          data-name="Path 888"
          d="M20776.132 6436.264c-3.856 4.309-5.524 10.418-10.016 14.062-2.729 2.195-6.182 3.241-9.357 4.734s-6.321 3.768-7.265 7.148c-1.054 3.8.98 7.689 2.049 11.494 1.1 3.936 1.171 8.048 1.236 12.167.073 4.982.154 9.965.066 14.947-.132 7.762-.775 15.883-4.895 22.461 14.874 4.734 30.691 5.377 46.289 5.985a46.709 46.709 0 008.992-.227 77.172 77.172 0 007.66-1.939 58.733 58.733 0 0115.261-1.953 25.623 25.623 0 006.7-.446 6.612 6.612 0 004.836-4.251c.52-1.946-.241-4.017-1.236-5.765-1.814-3.19-4.39-5.853-6.336-9a24.729 24.729 0 01-1.588-22.234c1.727-4.017 4.507-7.514 6.2-11.538a24.333 24.333 0 00-4.9-25.811c-5.9-6.043-14.376-8.384-22.483-9.628a20.42 20.42 0 01-9.467-3.658 16.2 16.2 0 00-10.784-2.092 17.6 17.6 0 00-10.967 5.546z"
          fill="#3f3d56"
        />
        <g data-name="Group 561" opacity=".1">
          <path
            data-name="Path 889"
            d="M20828.756 6479.225a24.341 24.341 0 00-1.866 11.172 23.923 23.923 0 011.866-7.931c1.719-4.017 4.5-7.514 6.2-11.538a23.344 23.344 0 001.7-10.623 22.751 22.751 0 01-1.7 7.389c-1.7 4.024-4.481 7.514-6.2 11.531z"
          />
          <path
            data-name="Path 890"
            d="M20752.996 6484.872c.044 2.868.088 5.743.1 8.611q0-5.926-.1-11.838c-.059-4.09-.132-8.231-1.236-12.174a60.293 60.293 0 01-2.195-7.565c-.651 3.585 1.2 7.221 2.195 10.8 1.106 3.906 1.179 8.077 1.236 12.166z"
          />
          <path
            data-name="Path 891"
            d="M20833.102 6520.507a24.738 24.738 0 01-6.694.446 58.692 58.692 0 00-15.254 1.917 77.682 77.682 0 01-7.66 1.932 46.221 46.221 0 01-9 .234c-15.071-.593-30.355-1.229-44.789-5.538a24.823 24.823 0 01-1.463 2.78c14.874 4.726 30.691 5.377 46.282 5.985a46.218 46.218 0 009-.234 75.665 75.665 0 007.631-1.924 58.692 58.692 0 0115.225-1.939 25.261 25.261 0 006.694-.454c2.166-.593 4.251-2.078 4.836-4.243a5.808 5.808 0 00-.073-3.044 6.83 6.83 0 01-4.735 4.082z"
          />
        </g>
        <path
          data-name="Path 892"
          d="M20811.433 6511.84c-.541 1.215-2.824 11.706-3.365 12.781s-3.5 18.29-3.768 19.256-19.483-4.039-19.483-4.039l-11.567-9.694-11.889-11.83s-.351-10.674 8.406-14.1a13.363 13.363 0 011.829-.571c10.623-2.553 9.555-34.854 9.555-34.854l21.8 9.416s-4.039 18.846-3.9 22.483c.037 1.222.995 1.983 2.246 2.444a17.757 17.757 0 005.955.644s4.722 6.857 4.181 8.064z"
          fill="#fbbebe"
        />
        <path
          data-name="Path 893"
          d="M20850.465 6547.236l3.095.812s2.29 3.482-3.095 6.724a93.27 93.27 0 00-9.826 6.87l-15.913 4.843-3.065-9.621 14.808-11.238z"
          fill="#07677e"
        />
        <path
          data-name="Path 894"
          d="M20850.465 6547.236l3.095.812s2.29 3.482-3.095 6.724a93.27 93.27 0 00-9.826 6.87l-15.913 4.843-3.065-9.621 14.808-11.238z"
          opacity=".1"
        />
        <path
          data-name="Path 895"
          d="M20734.334 6556.527l-6.189 6.058s11.164 12.92 19.754 13.725 14.127-9.826 14.127-9.826l-7.433-11.706z"
          fill="#07677e"
        />
        <path
          data-name="Path 896"
          d="M20734.334 6556.527l-6.189 6.058s11.164 12.92 19.754 13.725 14.127-9.826 14.127-9.826l-7.433-11.706z"
          opacity=".1"
        />
        <circle
          data-name="Ellipse 57"
          cx="21.531"
          cy="21.531"
          r="21.531"
          transform="translate(20771.596 6446.836)"
          opacity=".1"
        />
        <circle
          data-name="Ellipse 58"
          cx="21.531"
          cy="21.531"
          r="21.531"
          transform="translate(20771.596 6445.219)"
          fill="#fbbebe"
        />
        <path
          data-name="Path 897"
          d="M20831.757 6647.51a69.505 69.505 0 00-14.406 3.226c-8.048 2.678-71.113.044-71.991 0v-2.418l3.087-7.667 36.581-4.58h17.5s26.338 6.19 29.06 8.86c.111 1.606.169 2.579.169 2.579z"
          opacity=".1"
        />
        <path
          data-name="Path 898"
          d="M20811.433 6511.84c-.541 1.215-2.824 11.706-3.365 12.781s-3.5 18.29-3.768 19.256-19.483-4.039-19.483-4.039l-11.567-9.694-11.889-11.83s-.351-10.674 8.406-14.1l21.744 25 9.789-26.082a17.756 17.756 0 005.955.644s4.719 6.857 4.178 8.064z"
          opacity=".1"
        />
        <path
          data-name="Path 899"
          d="M20791.511 6530.02l-22.256-25.606a9.328 9.328 0 00-8.831-.651c-4.982 2.158-11.172 3.907-12.789 4.982s-7.675 7.733-7.675 7.733l18.042 47.2-7.945 31.086s1.214 15.883-1.88 21.67a23.784 23.784 0 00-2.561 11.977s.944 7.675-.132 11.706a19.5 19.5 0 00-.139 8.209s63.936 2.692 72.006 0a68.9 68.9 0 0114.406-3.226s-1.463-26.923-2.926-33.384 1.214-31.086 1.214-31.086l-1.749-26.382 10.491-27.07s-5.685-17.354-11.611-19.1c0 0-10.762-2.561-13.052-3.768s-9.021-2.29-9.021-2.29l-3.534 1.185z"
          fill="#07677e"
        />
        <rect
          data-name="Rectangle 175"
          width="51.242"
          height="78.415"
          rx="2.94"
          transform="rotate(3.89 -86051.398 309131.456)"
          opacity=".1"
        />
        <rect
          data-name="Rectangle 176"
          width="51.242"
          height="78.415"
          rx="2.94"
          transform="rotate(3.89 -86026.947 309154.372)"
          fill="#3f3d56"
        />
        <path
          data-name="Rectangle 177"
          fill="#fff"
          d="M20778.09 6554.516l44.54 3.029-4.577 67.314-44.54-3.028z"
        />
        <path
          data-name="Rectangle 178"
          opacity=".1"
          d="M20782.252 6572.179l36.383 2.547-.71 10.14-36.383-2.547z"
        />
        <path
          data-name="Rectangle 179"
          opacity=".1"
          d="M20811.547 6614.63l5.774.393-.36 5.284-5.773-.392z"
        />
        <path
          data-name="Rectangle 180"
          opacity=".1"
          d="M20782.07 6600.259l29.555 2.01-.36 5.284-29.554-2.01z"
        />
        <path
          data-name="Rectangle 181"
          fill="#3f3d56"
          d="M20786.344 6552.935l30.774 2.093-.552 8.124-30.774-2.093z"
        />
        <path
          data-name="Rectangle 182"
          opacity=".1"
          d="M20786.344 6552.935l30.774 2.093-.552 8.124-30.774-2.093z"
        />
        <path
          data-name="Path 900"
          d="M20794.203 6646.026s-.271 39.844-10.769 62.721c0 0 12.657-30.15 12.657-31.357s6.994-13.864 5.121-17.632-7.009-13.732-7.009-13.732z"
          opacity=".1"
        />
        <path
          data-name="Path 901"
          d="M20794.773 6461.366a14.977 14.977 0 012.436-10.03 12.357 12.357 0 009.555 13.023 1.617 1.617 0 01-.461-1.771c1.5 1.7 2.648 3.709 4.346 5.2s4.243 2.385 6.241 1.324c2.714-1.463 2.744-5.319 2.041-8.318a39.068 39.068 0 00-8.992-17.171 11.9 11.9 0 00-9.438-4.8 23.217 23.217 0 00-12.2 1.91 32.408 32.408 0 00-5.853 4.09l-10.243 8.355a9.723 9.723 0 00-2.487 2.619 7.17 7.17 0 00-.776 2.744 14.786 14.786 0 006.892 13.952 10.908 10.908 0 016.533-10.243 2.839 2.839 0 011.017 2.114l2.164-3.851a4.236 4.236 0 011.463-1.734c1.332-.732 2.992.132 4.126 1.163s2.239 2.319 3.761 2.48l.059-5.729"
          opacity=".1"
        />
        <path
          data-name="Path 902"
          d="M20794.772 6460.562a14.984 14.984 0 012.436-10.038 12.364 12.364 0 009.562 13.023 1.6 1.6 0 01-.461-1.763c1.5 1.7 2.648 3.7 4.346 5.2s4.243 2.385 6.241 1.317c2.714-1.463 2.744-5.319 2.041-8.311a39.068 39.068 0 00-8.992-17.171 14.391 14.391 0 00-5.026-3.907 14.633 14.633 0 00-4.39-.893 23.213 23.213 0 00-12.2 1.9 32.822 32.822 0 00-5.853 4.1l-10.243 8.355a9.622 9.622 0 00-2.487 2.619 7.133 7.133 0 00-.776 2.744 14.779 14.779 0 006.892 13.945 10.923 10.923 0 016.533-10.243 2.86 2.86 0 011.017 2.114l2.151-3.834a4.193 4.193 0 011.463-1.734c1.332-.732 2.992.132 4.126 1.163s2.239 2.312 3.76 2.48l.059-5.736"
          fill="#3f3d56"
        />
        <path
          data-name="Path 903"
          d="M20804.973 6596.371c-1.88-.951-32.974 3.9-32.974 3.9a177.945 177.945 0 00-17.5-3.5c-12.379-2.034-13.169-14.135-13.169-14.135l-1.353-24.224 4.178-3.658 17.9 11.706a57.814 57.814 0 010 6.987 9.851 9.851 0 00-.6 2.195.732.732 0 00.6.658c1.214.307 17.764 2.985 17.764 2.985s38.359-2.627 47.921 10.294a9.715 9.715 0 011.69 3.19c2.364 8.833-22.753 4.444-24.457 3.602z"
          fill="#fbbebe"
        />
        <path
          data-name="Path 904"
          d="M20829.446 6592.823c-1.463.651-2.37 1.119-2.37 1.119s-13.725-.4-21.436-3.2-17.083-2.3-17.083-2.3-32.133-5.531-27.15-12.752a.732.732 0 00.6.658c1.214.307 17.764 2.985 17.764 2.985s38.359-2.626 47.921 10.294a9.715 9.715 0 011.754 3.196z"
          opacity=".1"
        />
        <path
          data-name="Path 905"
          d="M20842.788 6550.199s1.888 13.323 2.019 14.406.812 14.127 0 15.613-2.019 3.9-2.019 3.9 1.346 2.824-4.039 3.907a55.267 55.267 0 00-11.706 4.3s-13.732-.4-21.4-3.226-17.091-2.29-17.091-2.29-40.788-7-23.287-15.547 29.879 3.029 29.879 3.029l19.512-1.207s7.272-4.448 9.292-4.038a7.47 7.47 0 004.17-.673l.139-14.135z"
          fill="#fbbebe"
        />
        <path
          data-name="Path 906"
          d="M20743.845 6517.49l-3.907-.2-11.837 46.092s12.781-3.234 18.29 0 15.613 3.9 15.613 3.9l-3.768-36.742z"
          opacity=".1"
        />
        <path
          data-name="Path 907"
          d="M20743.845 6516.683l-3.907-.2-11.837 46.087s12.781-3.234 18.29 0 15.613 3.9 15.613 3.9l-3.768-36.742z"
          fill="#07677e"
        />
        <path
          data-name="Path 908"
          d="M20833.37 6526.779l5.377 1.214s13.732 19.754 14.808 20.858-5.121 5.121-7.675 5.121-15.071 1.463-18.707 4.843-2.122-13.63-2.122-14.018 4.514-11.121 4.514-11.121z"
          opacity=".1"
        />
        <path
          data-name="Path 909"
          d="M20833.37 6525.975l5.377 1.207s13.732 19.79 14.808 20.866-5.121 5.121-7.675 5.121-15.071 1.463-18.707 4.843-2.122-13.63-2.122-14.018 4.543-11.157 4.543-11.157z"
          fill="#07677e"
        />
        <g data-name="Group 562" opacity=".1">
          <path
            data-name="Path 910"
            d="M20797.173 6450.59a10.791 10.791 0 01.037-1.683 14.976 14.976 0 00-2.253 5.524v2.041c0 1.185 0 2.378-.037 3.563h-.1v.549a2.919 2.919 0 00-.037-.563c-1.463-.234-2.509-1.463-3.6-2.444s-2.795-1.917-4.126-1.163a4.192 4.192 0 00-1.463 1.734l-2.173 3.834a2.831 2.831 0 00-1.017-2.107 10.908 10.908 0 00-6.533 10.243 14.866 14.866 0 01-6.943-11.655 14.793 14.793 0 006.943 13.264 10.923 10.923 0 016.533-10.243 2.861 2.861 0 011.017 2.114l2.151-3.834a4.192 4.192 0 011.463-1.734c1.332-.732 2.992.132 4.126 1.163s2.239 2.312 3.76 2.48q0-2.809.059-5.6a14.9 14.9 0 012.193-5.483z"
          />
          <path
            data-name="Path 911"
            d="M20794.696 6457.957c.037-.5.1-.995.168-1.463l.08-2.019a14.8 14.8 0 00-.249 3.482z"
          />
          <path
            data-name="Path 912"
            d="M20816.897 6466.686c-2 1.068-4.543.176-6.241-1.317s-2.846-3.5-4.346-5.2a1.617 1.617 0 00.461 1.771 1.726 1.726 0 01-.424-.11c1.463 1.683 2.626 3.658 4.309 5.121s4.243 2.385 6.241 1.317 2.568-3.57 2.392-6.007a5.079 5.079 0 01-2.392 4.425z"
          />
          <path
            data-name="Path 913"
            d="M20806.304 6461.813a12.437 12.437 0 01-9.116-10.872 12.357 12.357 0 009.584 12.606 1.61 1.61 0 01-.468-1.734z"
          />
        </g>
      </g>
      <g data-name="Group 564" transform="translate(514.143 224.196)">
        <path
          data-name="Rectangle 159"
          fill="#FFEE00"
          opacity=".1"
          d="M80.501 77.556h20.807v20.807H80.501z"
        />
        <path
          data-name="Rectangle 167"
          fill="#FFEE00"
          opacity=".1"
          d="M80.501 128.878h20.807v20.807H80.501z"
        />
        <path
          data-name="Rectangle 169"
          fill="#FFEE00"
          opacity=".1"
          d="M80.501 180.194h20.807v20.807H80.501z"
        />
        <path
          data-name="Rectangle 171"
          fill="#FFEE00"
          opacity=".1"
          d="M80.501 231.517h20.807v20.807H80.501z"
        />
        <path
          data-name="Rectangle 173"
          fill="#FFEE00"
          opacity=".1"
          d="M80.501 282.839h20.807v20.807H80.501z"
        />
        <path
          data-name="Path 867"
          d="M101.308 347.573v-13.418h-20.8v11.508z"
          fill="#FFEE00"
          opacity=".1"
        />
        <ellipse
          data-name="Ellipse 55"
          cx="71.289"
          cy="11.45"
          rx="71.289"
          ry="11.45"
          transform="translate(0 428.709)"
          fill="#07677e"
          opacity=".4"
        />
        <path
          data-name="Path 914"
          d="M772.45 425.15s2.883-.4 2.883-4.595 2.063-12.042 2.063-12.042 1.785-13.659 4.251-15.825 5.633-14.881 5.633-14.881.541-6.9 1.646-8.384 2.6-5.121 4.8-10.308 11.362-8.743 11.362-8.743 16.6-9.628 21.3-12.767a7.274 7.274 0 001.2-.907c.819-1.068 4.39-1.09 4.39-1.09a72.286 72.286 0 00.849-7.521v-.79a25.314 25.314 0 01-11.127-13.769c-.088-.278-.161-.563-.241-.849a2.378 2.378 0 01-1.459-1.288 25.81 25.81 0 00-.958-2.926c-.615-1.039-1.785-1.595-2.707-2.37-2.327-1.983-2.927-5.312-2.817-8.333.073-2.458.468-4.931.315-7.367a2.9 2.9 0 00-.044-.615c-.044-.358-.1-.732-.161-1.083-.358-1.814-1.141-3.526-1.58-5.326a6.852 6.852 0 01.541-5.377c1.5-2.275 4.624-2.729 7.367-2.926 3.109-.263 5.853.073 7.88-2.509a27.583 27.583 0 013.131-3.775c.41-.38 4.39-2.817 4.39-2.97a17.786 17.786 0 0112.438-.958c2.07.6 4.009 1.58 6.109 2.07 4.507 1.068 9.7-.088 13.535 2.495 2.136 1.463 3.417 3.8 4.617 6.058q1.463 2.795 2.97 5.6a36.008 36.008 0 013.943 9.577 16.221 16.221 0 01.271 2.246v1.163a4.015 4.015 0 01-.044.732 4.19 4.19 0 01-.051.454c-.051.154-.066.5-.11.732s-.132.651-.219.966a1.484 1.484 0 01-.132.41c-.044.139-.161.49-.256.732s-.1.256-.161.38a6.845 6.845 0 01-.373.732c-.059.1-.1.19-.161.285a8.285 8.285 0 01-.673.98c-1.558 1.953-3.87 3.2-5.575 5.026v.819a25.043 25.043 0 01-11.472 20.412c0 .278-.037.563-.051.849a41.765 41.765 0 00.08 6.511 3.087 3.087 0 012.427-1.085 3.484 3.484 0 01.937.08l.066-.051v.066c1.61.4 3.592 2.07 5.487 6.833 0 0 5.765 6.5 10.155 6.226s15.5 6.767 15.5 6.767 10.843 7.031 13.169 14.2a99.26 99.26 0 004.675 11.911l13.44 27.6 2.466 21.948s-1.368 9.738-1.1 11.23-5.626 14.881-5.626 14.881-19.479 34.219-27.438 35.975l-.571-.4a4.98 4.98 0 01-1.076.4l-1.639-1.149a17.128 17.128 0 00.132 3.856c1.09 3.387-.417 25.438-2.334 29.762s-1.236 61.024-1.236 61.024l.271 5a2.121 2.121 0 01-.066.439l.066 1.185-.2.1a14.142 14.142 0 00.2 4.77c.688 2.195.966 8.392.966 8.392s5.487 35.03 2.883 42.068-4.807 14.749-4.807 14.749-2.744 8.779-.132 10.243 10.009 4.06 8.5 7.711c-1.39 3.38-6.665 12.438-7.448 13.762l.066.732 1.075 11.655a14.631 14.631 0 01-1.236 4.448c-1.178 2.546-3.461 5.172-7.821 4.887a40.19 40.19 0 01-2.4-.241c-7.967-1.075-17.771-4.631-17.771-4.631a7.008 7.008 0 001.383-1.149 4.016 4.016 0 001.222-2.927c-.117-2.129 3.856-12.233 4.851-14.727l.227-.556s-9.057-9.474-7.55-17.859c0 0 10.023-5.853 6.724-9.072s-9.2-12.437-9.2-12.437-.271-34.5 0-39.639a42.725 42.725 0 00-.5-10.711 29.02 29.02 0 00-.38-1.566 93.467 93.467 0 01-13.8 1.046q-2.531 0-5.121-.1 0 .732-.066 1.58c-.38 8.545-1.09 23.536-1.668 29.1-.819 7.975-5.348 29.491-5.348 29.491s8.64 5.538-1.507 19.212c0 0 0 4.946.673 5.67a61.922 61.922 0 011.734 7.148c.424 2.568.6 5.18-.088 6.526-1.646 3.234-11.523 2.97-11.523 2.97a1.551 1.551 0 00-.241-.037 14.1 14.1 0 00-10.455 3.146c-3.753 3.014-17.991 1.7-25.709.732a137.385 137.385 0 01-5.041-.732 2.962 2.962 0 01-.1-1.054c.08-1.895 1.566-6.05 11.633-9.76 0 0 9.467-6.365 9.335-11.911h1.3c-.688-.022-1.171-.022-1.171-.022s3.709-13.528 2.195-14.632 3.022-16.1 3.022-16.1 2.6-25.168 2.744-26.923a15.466 15.466 0 00-.688-4.463l.688-13.806s.132-4.587 0-6.08a28.6 28.6 0 01.307-3.87l.2-1.573c-3.548-.9-5.853-1.727-5.853-1.727l.41-48.031c-3.014-5.853-3.57-18.7-3.556-27.8 0-5.853.263-10.184.263-10.184l-4.119-6.724s-.951-8.048.556-9.811a1.689 1.689 0 00-.183-2.3 7.662 7.662 0 00-.915-.644 1.155 1.155 0 00.1-.161 7.272 7.272 0 00-.914-.651s1.463-2.268.154-3.226a48.14 48.14 0 01-3.161 1.975c.059.534.117.841.117.841l-.351-.732c-.8.454-1.295.732-1.295.732s-6.453-12.854-6.314-14.742-4.39-9.877-4.39-9.877-.549-4.2-3.022-5.955-1.917-14.479-1.917-14.479-.688-6.628-2.334-9.328 1.47-6.369 1.47-6.369zm123.468-5.641l-.124 3.065c.732-1.178 1.258-2.019 1.258-2.019z"
          transform="translate(-765.711 -264.154)"
          fill="url(#b)"
        />
        <path
          data-name="Path 915"
          d="M22.861 216.189l1.58 6.731s12.657-6.475 14.932-14.669-3.812-11.318-3.812-11.318l-11.8 4.99z"
          fill="#fff"
        />
        <path
          data-name="Path 916"
          d="M22.861 216.189l1.58 6.731s12.657-6.475 14.932-14.669-3.812-11.318-3.812-11.318l-11.8 4.99z"
          opacity=".1"
        />
        <path
          data-name="Path 917"
          d="M93.896 445.269s11.706 4.3 19.754 4.843c4.273.285 6.519-2.334 7.675-4.858a14.852 14.852 0 001.214-4.39l-1.061-11.595-.556-6.167-17.1-4.448-2.422 7.411-.227.556c-.966 2.48-4.873 12.533-4.755 14.632a4.016 4.016 0 01-1.193 2.926 6.8 6.8 0 01-1.329 1.09z"
          fill="#fff"
        />
        <path
          data-name="Path 918"
          d="M13.975 439.364a2.924 2.924 0 00.1 1.054s25.036 4.17 30.157 0a13.557 13.557 0 0110.506-3.095s9.687.263 11.3-2.926c.673-1.339.5-3.936.08-6.489a62.238 62.238 0 00-1.7-7.111l-.388-.307-2.3-1.851-26.982-.8h-.2c.132 5.516-9.152 11.845-9.152 11.845-9.885 3.663-11.341 7.797-11.421 9.68z"
          fill="#fff"
        />
        <path
          data-name="Path 919"
          d="M13.967 439.369a3.014 3.014 0 00.11 1.054s25.036 4.17 30.15 0a13.557 13.557 0 0110.513-3.095s9.694.263 11.311-2.926c.666-1.339.5-3.936.08-6.5-3.731.373-9.621 1.3-11.933 3.526-3.5 3.365-9.423 6.731-13.052 7-2.867.18-19.921.721-27.179.941z"
          opacity=".1"
        />
        <path
          data-name="Path 920"
          d="M93.898 445.265s11.706 4.3 19.754 4.843c4.273.285 6.519-2.334 7.675-4.858-2.985 1-7.119 2.049-9.292 1.09-2.575-1.149-11.706-1.88-16.827-2.195a6.648 6.648 0 01-1.31 1.119z"
          opacity=".1"
        />
        <path
          data-name="Path 921"
          d="M76.528 98.56c9.657-3.753 22.08-16.154 18.978-21.948a13.118 13.118 0 01-1.207-4.653 42.471 42.471 0 01-.088-6.585 90.423 90.423 0 011.299-10.718s-30.15.68-28.394 5.121a16.475 16.475 0 01.454 6.094c-.146 2.524-.5 5.4-.885 7.821-.519 3.314-1.054 5.853-1.054 5.853s1.851 2.583 2.927 2.722-5.887 21.671 7.97 16.293z"
          fill="#cf6f80"
        />
        <path
          data-name="Path 922"
          d="M101.205 426.583l.227.249c9.014-10.9 19.915 2.692 19.915 2.692l.161-.293-.556-6.167-17.1-4.448-2.422 7.411z"
          opacity=".1"
        />
        <path
          data-name="Path 923"
          d="M34.533 418.613s6.585-.132 10.1 2.97 20.485.666 19.754 0a2.532 2.532 0 01-.38-1.119l-2.3-1.851-26.982-.8c-.112.514-.192.8-.192.8z"
          opacity=".1"
        />
        <path
          data-name="Path 924"
          d="M89.99 333.006a20.527 20.527 0 011.112 3.753 42.952 42.952 0 01.5 10.652c-.271 5.121 0 39.441 0 39.441s5.787 9.153 9.021 12.379-6.585 9.021-6.585 9.021c-1.463 8.348 7.4 17.771 7.4 17.771 9.014-10.9 19.915 2.685 19.915 2.685s5.926-10.243 7.4-13.9-5.787-6.182-8.34-7.675.132-10.243.132-10.243 2.151-7.675 4.712-14.676-2.824-41.848-2.824-41.848-.278-6.2-.944-8.355a14.15 14.15 0 01-.2-4.741c.044-.534.1-.973.132-1.28s.066-.439.066-.439l-.1-.176-3.658-6.819s-29.495 10.156-27.739 14.45z"
          fill="#07677e"
        />
        <path
          data-name="Path 925"
          d="M34.533 417.808s6.585-.139 10.1 2.926 20.485.673 19.754 0-.666-5.648-.666-5.648c9.957-13.6 1.463-19.117 1.463-19.117s4.441-21.4 5.246-29.338c.563-5.538 1.258-20.485 1.631-28.95.161-3.658.256-6.182.256-6.182l-8.062-1.6-1.046-.2-19.626-3.95s-.541 3.658-.907 6.65a29.217 29.217 0 00-.3 3.856c.124 1.463 0 6.051 0 6.051l-.673 13.725a15.829 15.829 0 01.673 4.441c-.139 1.756-2.692 26.784-2.692 26.784s-4.441 14.94-2.927 16.015-2.224 14.537-2.224 14.537z"
          fill="#07677e"
        />
        <path
          data-name="Path 926"
          d="M67.112 59.799a16.477 16.477 0 01.454 6.094 25.058 25.058 0 0026.646-.5 90.426 90.426 0 011.295-10.718s-30.149.683-28.395 5.124z"
          opacity=".1"
        />
        <path
          data-name="Path 927"
          d="M55.472 43.646a25.03 25.03 0 0050.057.6v-.6a25.036 25.036 0 00-50.072 0z"
          fill="#cf6f80"
        />
        <path
          data-name="Path 928"
          d="M76.528 98.561c9.657-3.753 22.08-16.154 18.978-21.948a13.118 13.118 0 01-1.207-4.653l-13.22 10.872-8.18 6.709-6.219-15.825c-.519 3.314-1.054 5.853-1.054 5.853s1.851 2.583 2.927 2.722-5.882 21.647 7.975 16.27z"
          opacity=".1"
        />
        <path
          data-name="Path 929"
          d="M42.339 146.606l11.04 185.464 14.4.944 37.291-107.54L98.954 97.8l-1.297-26.975L81.079 84.44 72.9 91.149l-6.4-16.293L54.6 85.23z"
          fill="#07677e"
        />
        <path
          data-name="Path 930"
          d="M89.99 333.006a20.528 20.528 0 011.112 3.753 106.081 106.081 0 0030.216-9.43l.2-.1-.066-1.178v-.615l-3.658-6.819s-29.56 10.094-27.804 14.389z"
          opacity=".1"
        />
        <path
          data-name="Path 931"
          d="M64.011 336.789a74.114 74.114 0 008.092.929c.161-3.658.256-6.182.256-6.182l-8.106-1.639z"
          opacity=".1"
        />
        <path
          data-name="Path 932"
          d="M42.647 332.399c5.2 1.353 13.242 2.875 20.427 1.924l.1-4.631-19.62-3.943s-.519 3.629-.907 6.65z"
          opacity=".1"
        />
        <path
          data-name="Path 933"
          d="M63.206 335.172c30 5.121 57.469-9.562 57.469-9.562l-.263-4.975s-.68-56.4 1.207-60.724 3.358-26.221 2.29-29.565 3.9-53.825 3.9-53.825l.8-20.485 29.477-11.977-13.169-27.458a99.217 99.217 0 01-4.58-11.852c-2.29-7.133-12.92-14.135-12.92-14.135s-10.9-6.994-15.21-6.731-9.957-6.189-9.957-6.189c-4.17-10.63-7.945-5.853-7.945-5.853a9.4 9.4 0 00.2 1.573c1.463 11.669-23.661 48.543-24.019 49.2l-2.422 58.28-2.422 73.754z"
          opacity=".1"
        />
        <path
          data-name="Path 934"
          d="M64.01 335.172c30 5.121 57.476-9.562 57.476-9.562l-.271-4.975s-.673-56.4 1.214-60.724 3.358-26.243 2.283-29.616 3.922-53.8 3.922-53.8l.812-20.485 29.47-11.977-13.169-27.458a100.765 100.765 0 01-4.58-11.845c-2.29-7.111-12.957-14.12-12.957-14.12s-10.9-6.994-15.2-6.731-9.979-6.182-9.979-6.182c-4.178-10.63-8.779-5.853-8.779-5.853 0 .512.439.732.2 1.573-3.219 11.318-22.856 48.543-23.214 49.2l-2.422 58.28-2.37 73.787z"
          fill="#fff"
        />
        <path
          data-name="Path 935"
          d="M72.095 124.261c3.226-1.346 20.317-20.858 20.317-20.858v-4.441c.622-1.463 4.324-.571 7.316.454L98.44 72.441l-1.463 1.214c-3.192 11.316-24.531 49.955-24.882 50.606z"
          opacity=".1"
        />
        <path
          data-name="Path 936"
          d="M71.282 122.654c3.234-1.353 20.324-20.858 20.324-20.858v-4.448c.622-1.463 4.317-.571 7.316.454l-1.265-26.948-1.463 1.207c-3.222 11.293-24.553 49.933-24.912 50.593z"
          fill="#fff"
        />
        <path
          data-name="Path 937"
          d="M120.674 219.957c-.4 0-20.859-2.151-20.859-2.151s-12.386 24.363-11.574 30.282 2.283 11.172 7.265 10.243 26.814.732 26.814.732z"
          opacity=".1"
        />
        <path
          data-name="Path 938"
          d="M121.488 218.34c-.41 0-20.866-2.151-20.866-2.151s-12.379 24.4-11.574 30.252 2.29 11.172 7.265 10.243 26.821.732 26.821.732z"
          fill="#fff"
        />
        <path
          data-name="Path 939"
          d="M106.072 206.935s-18.773 10.1-19.176 13.169 9.555-1.346 11.706-1.888a27.911 27.911 0 014.309-.673l14.347.388z"
          fill="#cf6f80"
        />
        <circle
          data-name="Ellipse 59"
          cx="1.975"
          cy="1.975"
          transform="translate(75.365 121.569)"
          opacity=".1"
          r="1.975"
        />
        <circle
          data-name="Ellipse 60"
          cx="1.975"
          cy="1.975"
          transform="translate(75.365 120.765)"
          fill="#3f3d56"
          r="1.975"
        />
        <circle
          data-name="Ellipse 61"
          cx="1.975"
          cy="1.975"
          transform="translate(71.728 207.08)"
          opacity=".1"
          r="1.975"
        />
        <circle
          data-name="Ellipse 62"
          cx="1.975"
          cy="1.975"
          transform="translate(71.728 206.268)"
          fill="#3f3d56"
          r="1.975"
        />
        <circle
          data-name="Ellipse 63"
          cx="1.975"
          cy="1.975"
          transform="translate(73.39 164.325)"
          opacity=".1"
          r="1.975"
        />
        <circle
          data-name="Ellipse 64"
          cx="1.975"
          cy="1.975"
          transform="translate(73.39 163.52)"
          fill="#3f3d56"
          r="1.975"
        />
        <path
          data-name="Path 940"
          d="M29.825 217.136s-1.346 2.019 0 2.926-.132 3.234-.132 3.234 3.358 1.961 1.88 3.739-.541 9.76-.541 9.76l4.038 6.724s-.241 4.309-.256 10.133c0 9.087.534 21.861 3.49 27.684l-.4 47.782s14.142 5.172 25.98 3.592l1.756-76.673s-2.561-43.48-3.5-51.82a86.808 86.808 0 01-.673-13.059s.4-13.052 1.756-19.1c0 0 1.463-26.25 1.61-33.515.066-3.475-.117-13.615-.322-23.258a5519.428 5519.428 0 00-.483-20.485l2.67-21.136s-2.67-.263-3.475.8a7.7 7.7 0 01-1.171.9c-4.617 3.117-20.9 12.7-20.9 12.7s-9.014 3.585-11.172 8.721-3.658 8.779-4.7 10.243-1.617 8.34-1.617 8.34-3.1 12.657-5.524 14.8-4.163 15.752-4.163 15.752l21.4 16.827s1.88 27.992 2.283 29.074-7.834 25.315-7.834 25.315z"
          fill="#fff"
        />
        <path
          data-name="Path 941"
          d="M29.018 217.131s-1.339 2.019 0 2.926-.124 3.234-.124 3.234 3.358 1.961 1.88 3.739-.541 9.76-.541 9.76l4.024 6.724s-.241 4.309-.263 10.133c0 9.087.534 21.861 3.49 27.684l-.4 47.782s14.142 5.172 25.98 3.592l1.749-76.673s-2.553-43.48-3.5-51.82a86.016 86.016 0 01-.666-13.059s.4-13.052 1.749-19.1c0 0 1.463-26.25 1.617-33.515.066-3.475-.117-13.615-.322-23.258a5519.428 5519.428 0 00-.483-20.485l3.526-21.422s-3.526 0-4.339 1.09a6.942 6.942 0 01-1.171.9c-4.609 3.117-20.9 12.7-20.9 12.7s-8.992 3.585-11.187 8.721-3.658 8.779-4.7 10.243-1.617 8.34-1.617 8.34-3.1 12.657-5.524 14.8-4.17 15.752-4.17 15.752l21.4 16.827s1.88 27.992 2.29 29.074-7.798 25.311-7.798 25.311z"
          fill="#fff"
        />
        <path
          data-name="Path 942"
          d="M54.644 101.004l-1.939 5.633 10.177 10.243a5519.428 5519.428 0 00-.483-20.485l3.526-21.414s-3.526 0-4.339 1.09a6.943 6.943 0 01-1.171.9l-8.648 24.941z"
          opacity=".1"
        />
        <path
          data-name="Path 943"
          d="M55.472 99.387l-1.939 5.626 10.169 10.243c-.219-10.543-.483-20.485-.483-20.485l3.534-21.422s-3.534 0-4.339 1.09a7.325 7.325 0 01-1.171.9l-8.7 24.963z"
          fill="#fff"
        />
        <path
          data-name="Path 944"
          d="M55.472 43.646a24.954 24.954 0 001.229 7.762 1.039 1.039 0 00.79-.19c.2-6.585 3.431-12.774 7.419-18.034a19.1 19.1 0 014.024-4.17 7.88 7.88 0 015.458-1.544c2.195.3 4.134 1.792 6.35 1.983 2.927.241 5.546-1.785 8.45-1.88a8.282 8.282 0 016.211 2.883 16.943 16.943 0 013.329 6.167 36.128 36.128 0 011.858 10.652c.037 2.048.234 4.616 2.136 5.363a10.9 10.9 0 012.758-8.34l.044-.051v-.6a25.036 25.036 0 00-50.072 0z"
          opacity=".1"
        />
        <path
          data-name="Path 945"
          d="M70.105 3.897a17.237 17.237 0 0112.16-.951c2.027.6 3.936 1.573 5.992 2.063 4.39 1.061 9.511-.088 13.279 2.48 2.092 1.463 3.351 3.775 4.521 6.029l2.927 5.568a36.176 36.176 0 013.87 9.511c.666 3.358.263 7.119-1.866 9.826-1.544 1.961-3.841 3.2-5.524 5.048a10.974 10.974 0 00-2.751 8.362c-1.9-.732-2.092-3.314-2.136-5.363a36.172 36.172 0 00-1.858-10.652 16.944 16.944 0 00-3.329-6.168 8.289 8.289 0 00-6.211-2.89c-2.927.1-5.553 2.129-8.45 1.88-2.195-.183-4.141-1.675-6.35-1.975a7.843 7.843 0 00-5.458 1.544 18.743 18.743 0 00-4.017 4.17c-3.995 5.268-7.236 11.428-7.426 18.034-.827.6-2.019-.19-2.429-1.127a26.762 26.762 0 00-.944-2.926c-.6-1.032-1.749-1.588-2.648-2.363-2.283-1.968-2.853-5.282-2.766-8.289s.673-6.058.1-9.013c-.344-1.807-1.119-3.512-1.544-5.3a6.935 6.935 0 01.527-5.348c1.463-2.261 4.543-2.714 7.228-2.926 3.051-.263 5.78.073 7.726-2.495a28.6 28.6 0 013.073-3.76c.405-.394 4.304-2.808 4.304-2.969z"
          fill="#512e4e"
        />
        <path
          data-name="Path 946"
          d="M149.646 158.179l7.638-14.128 2.422 21.8s-1.346 9.687-1.075 11.172-5.516 14.8-5.516 14.8-19.117 34.057-26.924 35.805l-26.339-18.843 6.994-8.882s2.422-.944 3.029 0c0 0 12.994-22.344 14.332-23.953s1.083-4.851 1.083-4.851 2.019-2.151 1.346-4.17 3.863-9.013 3.863-9.013l-4.17-3.9z"
          opacity=".1"
        />
        <path
          data-name="Path 947"
          d="M156.882 142.435l2.019 1.617 2.422 21.8s-1.346 9.687-1.075 11.172-5.524 14.8-5.524 14.8-19.11 34.057-26.916 35.805l-26.383-18.844 7-8.882s2.422-.944 3.029 0c0 0 12.986-22.343 14.332-23.953s1.075-4.851 1.075-4.851 2.019-2.151 1.346-4.17 3.907-9.013 3.907-9.013l-4.17-3.9z"
          fill="#fff"
        />
        <path
          data-name="Path 948"
          d="M31.578 227.873c-1.463 1.778-.541 9.767-.541 9.767l4.039 6.68s-.241 4.317-.256 10.14l6.789 2.122a4.039 4.039 0 005.238-3.98l-1.178-37.751-15.84 6.05c1.346.937-.132 3.234-.132 3.234s3.359 1.96 1.881 3.738z"
          opacity=".1"
        />
        <path
          data-name="Path 949"
          d="M30.774 227.069c-1.463 1.77-.541 9.76-.541 9.76l4.024 6.687s-.241 4.309-.263 10.133l6.914 2.158a3.944 3.944 0 005.121-3.885l-1.178-37.883-15.832 6.065c1.353.936-.124 3.234-.124 3.234s3.356 1.953 1.879 3.731z"
          fill="#fff"
        />
        <path
          data-name="Path 950"
          d="M25.519 209.056s1.075 6.87 3.768 7.272 3.9 11.113 6.585 10.74.907-9.965.812-11.823 2.926-9.555.673-11.3-9.423 0-9.423 0z"
          fill="#cf6f80"
        />
        <path
          data-name="Path 951"
          d="M19.827 156.161l-5.07-10.243s-2.027 7.806-2.027 11.977-2.824 4.58-2.824 4.58-3.095 3.658-1.463 6.328 2.283 9.284 2.283 9.284-.534 12.65 1.888 14.4 2.963 5.926 2.963 5.926 4.441 7.938 4.3 9.826 6.19 14.669 6.19 14.669-3.095-15.883 14.94-22.746c0 0 .139-5.385-1.207-6.862s-3.446-2.195-2.129-9.628.38-16.4.38-18.188-4.037-12.966-4.037-12.966z"
          opacity=".1"
        />
        <path
          data-name="Path 952"
          d="M17.574 144.454l-4.434 1.463s-2.027 7.806-2.027 11.977-2.824 4.58-2.824 4.58-3.095 3.658-1.463 6.328 2.29 9.284 2.29 9.284-.541 12.65 1.88 14.4 2.927 5.926 2.927 5.926 4.441 7.938 4.3 9.826 6.2 14.669 6.2 14.669-3.095-15.883 14.94-22.746c0 0 .132-5.385-1.214-6.862s-3.446-2.195-2.129-9.628.38-16.4.38-18.188-4.039-12.964-4.039-12.964z"
          fill="#fff"
        />
        <path
          data-name="Path 953"
          d="M115.523 409.935s-7.067-4.441-11.706-1.214 11.706 1.214 11.706 1.214z"
          opacity=".1"
        />
        <path
          data-name="Path 954"
          d="M60.593 396.203a14.307 14.307 0 00-11.508 4.851c-5.254 5.655 11.508-4.851 11.508-4.851z"
          opacity=".1"
        />
        <g data-name="Group 563" opacity=".1">
          <path
            data-name="Path 955"
            d="M51.455 42.387c.9.783 2.056 1.332 2.656 2.363a27.268 27.268 0 01.937 2.926c.41.944 1.6 1.727 2.436 1.127.19-6.585 3.431-12.767 7.419-18.034a18.709 18.709 0 014.017-4.163 7.865 7.865 0 015.465-1.551c2.195.3 4.126 1.792 6.343 1.983 2.927.241 5.553-1.785 8.458-1.88a8.253 8.253 0 016.2 2.883 16.942 16.942 0 013.329 6.167 36.17 36.17 0 011.858 10.652c.044 2.041.234 4.587 2.122 5.348a10.14 10.14 0 000 1.632c-1.909-.732-2.1-3.314-2.144-5.363a36.175 36.175 0 00-1.858-10.652 16.941 16.941 0 00-3.329-6.168 8.282 8.282 0 00-6.2-2.89c-2.927.1-5.56 2.129-8.458 1.88-2.195-.183-4.141-1.675-6.343-1.975a7.865 7.865 0 00-5.465 1.544 18.746 18.746 0 00-4.016 4.17c-3.987 5.268-7.228 11.428-7.419 18.034-.834.6-2.027-.19-2.436-1.127a28.423 28.423 0 00-.937-2.926c-.6-1.032-1.756-1.588-2.656-2.363-2.283-1.968-2.853-5.282-2.766-8.289v-.278c.141 2.618.841 5.274 2.787 6.95z"
          />
          <path
            data-name="Path 956"
            d="M105.47 41.875c1.675-1.851 3.973-3.095 5.516-5.055a10.616 10.616 0 002.133-5.985 11.274 11.274 0 01-2.129 7.6c-1.544 1.961-3.841 3.2-5.516 5.048a10.973 10.973 0 00-2.766 6.526 10.974 10.974 0 012.766-8.136z"
          />
          <path
            data-name="Path 957"
            d="M47.248 19.78c.432 1.792 1.2 3.5 1.551 5.3a16.936 16.936 0 01.227 3.7 14.2 14.2 0 00-.227-2.085c-.351-1.807-1.119-3.512-1.551-5.3a9.189 9.189 0 01-.241-3.029 10.148 10.148 0 00.241 1.412z"
          />
        </g>
      </g>
      <path d="M244.45 430.457h202.962v-265.53H244.45z" fill="#fff" />
      <path
        d="M451.259 161.08h-210.66v273.223h210.66V161.08m-7.694 7.693V426.61H248.292V168.773h195.273"
        fill="#07677e"
      />
      <path
        d="M402.95 426.61h-1.451a49.71 49.71 0 001.451-.3v.3m-46 0H248.293v-14.517a34.374 34.374 0 009.743 5.835v2.121h6.314a97.979 97.979 0 0021.979 2.971c17.294.586 34.33.328 51.641 1.7 5.82.462 12.257 1.207 18.981 1.891m86.616-103.088a5.715 5.715 0 01-1.21-.178 4.794 4.794 0 01-.458-.149c1.585-29.162-.593-58.356-2.41-87.507-1.047-16.808-2.506-33.665-6.506-50.2-1.356-5.6-2.937-11.164-4.557-16.718h15.141V323.52"
        fill="#fff"
      />
      <path
        d="M402.951 434.303H240.599v-34.168a38.972 38.972 0 002.823 6.064 23.337 23.337 0 004.871 5.893v14.517h108.658a255.735 255.735 0 0025.619 1.6 100.567 100.567 0 0018.932-1.6h1.449v7.694m40.947-110.775c-.112 0-.223 0-.334-.008V168.773h-15.14c-.747-2.565-1.5-5.128-2.25-7.693h25.085v160.907c-2.469.577-5.113 1.542-7.36 1.542"
        fill="#07677e"
      />
      <path
        d="M248.293 252.064v-83.291h18.38q-.229 1.165-.468 2.328a91.688 91.688 0 01-.983 4.235h-7.186v25.022a428.3 428.3 0 00-9.743 51.707"
        fill="#fff"
      />
      <path
        d="M240.599 361.284v-200.2h27.524c-.481 2.564-.949 5.131-1.45 7.693h-18.38v83.291c-2.345 18.156-3.727 36.4-4.553 54.481-.795 17.514-.17 35.346-2.828 52.752-.1.661-.208 1.325-.313 1.986"
        fill="#07677e"
      />
      <path d="M261.32 416.76h164.865V178.62H261.32z" fill="#fff" />
      <path
        d="M429.469 175.335H258.036v244.713h171.433V175.335m-6.569 6.568v231.578H264.6V181.904h158.3"
        fill="#07677e"
      />
      <path
        d="M402.952 413.479h-26.474a256.25 256.25 0 0024.909-4.542 10.061 10.061 0 001.565 3.214v1.328m-92.607 0h-45.741v-28.388a29.9 29.9 0 006.506 11.994v5.143h5.761a43.052 43.052 0 008.075 4.474 103.644 103.644 0 0025.4 6.777m-45.741-56.88v-174.7h51.19c-11.65 1.527-21.908 4.955-30.4 11.25H271.11v17.585c-3.605 8.191-4.922 17.325-5.751 25.571-1.11 11.047-.319 22.175.528 33.215 1.314 17.154 6.249 33.823 2.647 51.018-2.476 11.825-3.235 23.971-3.93 36.058m158.3-168.594c-15.572-3.967-31.956-4.922-48.449-5.457-4.543-.148-9.083-.389-13.624-.646h62.074v6.1"
        fill="#fff"
      />
      <path
        d="M402.948 420.049H258.036V175.335h171.433v14.546q-3.257-1.036-6.569-1.875v-6.1h-62.074c-8.826-.5-17.652-1.048-26.486-1.048-3.786 0-7.573.1-11.362.35q-3.673.242-7.184.7h-51.19v174.7c-.313 5.452-.612 10.89-1.049 16.284a35.2 35.2 0 001.049 12.208v28.388h45.744a231.234 231.234 0 0033.594 2.087c.84 0 1.679 0 2.51-.008a241.178 241.178 0 0030.028-2.079h26.468v6.568"
        fill="#07677e"
      />
      <path d="M274.394 398.945h138.712V196.438H274.394z" fill="#fff" />
      <path
        d="M416.391 193.154H271.11V402.23h145.28V193.154m-6.569 6.569v195.939H277.679V199.723h132.143"
        fill="#07677e"
      />
      <path
        d="M386.657 395.661H277.679v-6.208c5.3.4 10.677.627 16.06.627 22.006 0 44.116-3.793 61.814-14.973a92.63 92.63 0 0029.032-29.063c.523 2.7 1.727 5.711 1.725 8.221a5.96 5.96 0 01-.185 1.539c-1.085 4.065-8.229 7.478-8.229 11.886 0 4.408 7.145 7.822 8.229 11.886a5.953 5.953 0 01.185 1.538c0 3.206-1.963 7.223-1.962 10.384a4.868 4.868 0 00.587 2.484 4.848 4.848 0 001.723 1.679m2.131-56.912c7.792-14.906 11.815-31.364 13.287-47.284 2.842-30.707-5.155-61.275-8.979-91.743h16.725v122.3a13.906 13.906 0 00-3.157-.456 4.879 4.879 0 00-2.485.587c-3.737 2.162-3.132 10.05-6.162 13.083-1.984 1.984-6.05 2.41-9.228 3.515"
        fill="#fff"
      />
      <path
        d="M399.363 402.23H271.11v-13.368c.4.04.785.084 1.182.124q2.679.262 5.387.468v6.208h108.979c3.193 1.958 8.889 2.012 11.359 4.485a6.8 6.8 0 011.347 2.083m17.027-78.724a45.6 45.6 0 01-6.569-1.485v-122.3h-16.726q-.374-2.987-.693-5.974c-.02-.2-.061-.4-.089-.595h24.076v130.351"
        fill="#07677e"
      />
      <path
        d="M405.922 403.219h49.1v63.242L431.751 451.4l-25.829 15.308v-63.49"
        fill="#fff"
      />
      <path
        d="M457.99 400.248h-55.038v71.672l28.73-17.026 26.308 17.026v-71.672m-5.94 5.94v54.813l-17.14-11.094-3.09-2-3.166 1.876-19.761 11.709v-55.3h43.157"
        fill="#07677e"
      />
      <path
        d="M408.892 461.496v-9.746a45.288 45.288 0 0027.469-9.715c8.8-6.877 11.927-18.541 13.3-29.051.807.219 1.608.427 2.386.579v47.44l-17.141-11.094-3.09-2-3.166 1.876-19.758 11.711"
        fill="#fff"
      />
      <path
        d="M457.99 471.92l-26.308-17.026-28.73 17.026v-20.552a42.039 42.039 0 005.671.382h.27v9.746l19.76-11.712 3.166-1.876 3.09 2 17.141 11.094v-47.439a11.654 11.654 0 002.228.251 4.877 4.877 0 002.485-.587 4.4 4.4 0 001.227-1.075v59.769"
        fill="#07677e"
      />
      <path
        d="M430.471 416.951c-1.031 0-2.9-1.9-4.264-3.278-2-2.023-4.059-4.115-6.767-4.838a9.167 9.167 0 00-2.4-.3 23.572 23.572 0 00-6.1 1.1 19.042 19.042 0 01-4.281.859 1.815 1.815 0 01-.829-.142c-.832-.48-1.493-3.016-1.977-4.868-.728-2.786-1.481-5.668-3.5-7.687s-4.9-2.774-7.688-3.5c-1.851-.483-4.385-1.145-4.867-1.979-.46-.794.247-3.391.716-5.108.763-2.8 1.554-5.7.8-8.5-.721-2.7-2.813-4.769-4.837-6.765-1.384-1.365-3.278-3.234-3.278-4.265s1.894-2.9 3.278-4.264c2.023-2 4.116-4.059 4.837-6.768.749-2.8-.041-5.693-.8-8.495-.469-1.718-1.178-4.314-.718-5.106.483-.834 3.018-1.5 4.87-1.981 2.786-.727 5.668-1.48 7.687-3.5s2.773-4.9 3.5-7.689c.483-1.851 1.145-4.387 1.979-4.87a1.834 1.834 0 01.827-.14 19.028 19.028 0 014.279.859 23.608 23.608 0 006.1 1.1 9.3 9.3 0 002.389-.3c2.711-.724 4.775-2.816 6.771-4.839 1.364-1.384 3.233-3.278 4.264-3.278s2.9 1.894 4.264 3.278c2 2.023 4.058 4.115 6.765 4.838a9.344 9.344 0 002.4.3 23.6 23.6 0 006.1-1.1 19.042 19.042 0 014.278-.859 1.7 1.7 0 01.823.139c.838.484 1.5 3.019 1.983 4.87.729 2.787 1.482 5.669 3.5 7.689s4.9 2.772 7.689 3.5c1.851.483 4.385 1.144 4.869 1.979.458.791-.251 3.389-.72 5.107-.764 2.8-1.555 5.7-.806 8.5.723 2.706 2.815 4.768 4.837 6.764 1.384 1.365 3.278 3.234 3.278 4.265s-1.894 2.9-3.279 4.267c-2.021 1.995-4.113 4.058-4.836 6.765-.749 2.8.041 5.694.806 8.5.468 1.719 1.178 4.316.718 5.109-.482.831-3.016 1.492-4.868 1.976-2.788.728-5.671 1.481-7.692 3.5s-2.77 4.9-3.5 7.685c-.484 1.852-1.146 4.388-1.981 4.87a1.7 1.7 0 01-.827.141 19.04 19.04 0 01-4.282-.859 23.565 23.565 0 00-6.1-1.1 9.122 9.122 0 00-2.4.3c-2.7.721-4.765 2.813-6.76 4.836-1.365 1.383-3.233 3.278-4.264 3.278"
        fill="#fff"
      />
      <path
        d="M430.472 315.116c-4.408 0-7.82 7.143-11.886 8.228a5.98 5.98 0 01-1.538.186c-3.211 0-7.223-1.965-10.384-1.965a4.879 4.879 0 00-2.485.587c-3.737 2.162-3.132 10.05-6.162 13.083s-10.921 2.426-13.082 6.161c-2.133 3.682 2.315 10.2 1.19 14.408-1.085 4.065-8.229 7.478-8.229 11.886s7.145 7.822 8.229 11.887c1.125 4.206-3.323 10.725-1.19 14.406 2.161 3.737 10.051 3.131 13.082 6.164s2.426 10.919 6.162 13.081a4.88 4.88 0 002.485.587c3.16 0 7.172-1.964 10.38-1.964a5.946 5.946 0 011.542.186c4.066 1.086 7.477 8.228 11.886 8.228s7.819-7.143 11.884-8.228a5.945 5.945 0 011.544-.186c3.206 0 7.217 1.964 10.379 1.964a4.877 4.877 0 002.485-.587c3.737-2.162 3.133-10.048 6.161-13.081s10.921-2.427 13.084-6.162c2.13-3.683-2.317-10.2-1.191-14.408 1.087-4.065 8.227-7.478 8.227-11.887s-7.141-7.821-8.227-11.886c-1.126-4.206 3.323-10.726 1.191-14.408-2.164-3.735-10.048-3.13-13.081-6.161s-2.429-10.92-6.165-13.083a4.877 4.877 0 00-2.485-.587c-3.156 0-7.172 1.965-10.379 1.965a5.989 5.989 0 01-1.544-.186c-4.065-1.086-7.475-8.228-11.884-8.228m0 7.066c.6.528 1.349 1.284 1.907 1.85 2.2 2.229 4.69 4.755 8.269 5.712a12.628 12.628 0 003.252.411 26.5 26.5 0 006.974-1.222c.751-.205 1.618-.441 2.336-.592.24.732.485 1.671.67 2.384.763 2.914 1.708 6.538 4.365 9.194s6.281 3.6 9.194 4.362c.713.187 1.652.432 2.383.671-.156.738-.4 1.647-.594 2.339-.8 2.923-1.79 6.562-.81 10.222.955 3.577 3.483 6.068 5.711 8.268.566.558 1.322 1.3 1.85 1.909-.528.6-1.285 1.35-1.851 1.909-2.228 2.2-4.754 4.69-5.709 8.264-.98 3.663.012 7.3.809 10.225.189.692.437 1.6.594 2.339-.732.24-1.671.484-2.382.67-2.915.761-6.541 1.707-9.2 4.367s-3.6 6.277-4.357 9.188a44.649 44.649 0 01-.67 2.387c-.716-.151-1.585-.387-2.341-.594a26.452 26.452 0 00-6.969-1.222 12.561 12.561 0 00-3.252.411c-3.579.955-6.071 3.483-8.27 5.712-.557.566-1.3 1.322-1.906 1.85-.6-.528-1.349-1.284-1.906-1.85-2.2-2.229-4.692-4.756-8.267-5.711a12.592 12.592 0 00-3.255-.412 26.459 26.459 0 00-6.971 1.222c-.753.205-1.62.442-2.339.592-.24-.732-.485-1.671-.67-2.383-.761-2.913-1.708-6.538-4.361-9.191s-6.281-3.6-9.2-4.366c-.714-.186-1.654-.432-2.385-.671.157-.738.4-1.647.595-2.34.8-2.923 1.789-6.56.809-10.218-.954-3.579-3.482-6.072-5.713-8.272-.566-.558-1.321-1.3-1.849-1.907.529-.6 1.283-1.349 1.849-1.908 2.231-2.2 4.758-4.692 5.712-8.268.98-3.663-.012-7.3-.809-10.224-.19-.692-.437-1.6-.595-2.339.733-.239 1.673-.484 2.386-.671 2.913-.761 6.538-1.707 9.2-4.363s3.6-6.28 4.361-9.192c.185-.714.431-1.654.67-2.386.715.151 1.584.388 2.337.594a26.5 26.5 0 006.977 1.222 12.634 12.634 0 003.248-.411c3.578-.955 6.071-3.483 8.27-5.713.558-.565 1.3-1.321 1.907-1.849"
        fill="#07677e"
      />
      <path
        d="M430.78000000000003 420.263h.016-.016m.048 0h.023-.023m.038 0h.036-.036m.036 0c2.861-.3 5.313-3.514 7.828-5.862-2.517 2.349-4.968 5.559-7.829 5.862M460.263 328.955a48.492 48.492 0 00-.688-2.453c.252.788.471 1.62.69 2.452M430.472 413.198c-.6-.528-1.349-1.284-1.906-1.85l-.3-.3q1.539.718 3.108 1.3c-.31.3-.622.6-.9.847m-22.738-6.16c-.24-.732-.485-1.671-.67-2.383-.761-2.913-1.708-6.538-4.361-9.191s-6.281-3.6-9.2-4.366c-.714-.186-1.654-.432-2.385-.671.157-.738.4-1.647.595-2.34.8-2.923 1.789-6.56.81-10.218-.954-3.579-3.482-6.072-5.713-8.272-.566-.558-1.321-1.3-1.849-1.907.528-.6 1.283-1.349 1.849-1.908 2.231-2.2 4.758-4.692 5.712-8.268.98-3.663-.012-7.3-.809-10.224-.19-.692-.437-1.6-.595-2.339.733-.239 1.673-.484 2.386-.671 2.913-.761 6.538-1.707 9.2-4.363s3.6-6.28 4.361-9.192c.185-.714.431-1.654.67-2.386.715.151 1.584.388 2.337.594a26.5 26.5 0 006.977 1.222 12.635 12.635 0 003.248-.411c3.579-.955 6.071-3.483 8.27-5.713.558-.565 1.3-1.321 1.907-1.849.6.529 1.349 1.284 1.907 1.85 2.2 2.229 4.69 4.755 8.269 5.712a12.628 12.628 0 003.252.411 26.5 26.5 0 006.974-1.222c.751-.205 1.618-.441 2.336-.592.111.341.224.726.332 1.113-5.757.487-11.5 1.14-17.2 2.053a36.867 36.867 0 00-5.869-.468 36.651 36.651 0 00-36.651 36.652 36.649 36.649 0 0019.809 32.562 51.029 51.029 0 005.574 5.147 13.085 13.085 0 00-2.165-.176 26.459 26.459 0 00-6.971 1.222c-.753.205-1.62.442-2.339.592"
        fill="#fff"
      />
      <path
        d="M430.472 420.264c-4.408 0-7.82-7.143-11.886-8.228a5.946 5.946 0 00-1.542-.186c-3.207 0-7.219 1.964-10.38 1.964a4.88 4.88 0 01-2.485-.587c-3.737-2.162-3.132-10.051-6.162-13.081s-10.921-2.428-13.082-6.164a4.869 4.869 0 01-.587-2.484c0-3.16 1.964-7.177 1.962-10.384a5.955 5.955 0 00-.185-1.538c-1.085-4.065-8.229-7.478-8.229-11.886s7.145-7.821 8.229-11.886a5.961 5.961 0 00.185-1.539c0-3.207-1.963-7.224-1.962-10.384a4.869 4.869 0 01.587-2.484c2.161-3.736 10.051-3.131 13.082-6.161s2.426-10.921 6.162-13.083a4.88 4.88 0 012.485-.587c3.16 0 7.172 1.965 10.384 1.965a5.98 5.98 0 001.538-.186c4.066-1.086 7.477-8.228 11.886-8.228s7.819 7.143 11.884 8.228a5.988 5.988 0 001.544.186c3.206 0 7.222-1.965 10.379-1.965a4.877 4.877 0 012.485.587c1.417.82 2.209 2.462 2.813 4.351.251.789.47 1.62.688 2.453q-3.364.216-6.723.5a26.462 26.462 0 00-.332-1.113c-.718.151-1.585.387-2.336.592a26.5 26.5 0 01-6.974 1.222 12.628 12.628 0 01-3.252-.411c-3.579-.956-6.071-3.483-8.269-5.712-.558-.566-1.3-1.322-1.907-1.85-.6.529-1.349 1.284-1.907 1.849-2.2 2.23-4.691 4.757-8.27 5.713a12.636 12.636 0 01-3.248.41 26.5 26.5 0 01-6.977-1.222c-.754-.205-1.623-.443-2.337-.594-.24.733-.485 1.673-.67 2.386-.761 2.912-1.707 6.536-4.361 9.192s-6.282 3.6-9.2 4.363c-.714.187-1.654.433-2.386.671.157.738.4 1.647.595 2.339.8 2.923 1.789 6.561.809 10.224-.953 3.576-3.481 6.068-5.712 8.268-.566.558-1.321 1.3-1.849 1.908.529.6 1.283 1.349 1.849 1.907 2.231 2.2 4.758 4.693 5.713 8.272.979 3.657-.013 7.294-.81 10.218-.19.693-.437 1.6-.595 2.34.732.24 1.672.485 2.385.671 2.915.762 6.541 1.708 9.2 4.366s3.6 6.278 4.361 9.191c.185.713.431 1.652.67 2.383.719-.15 1.586-.387 2.339-.592a26.46 26.46 0 016.971-1.222 13.086 13.086 0 012.165.176q1.184.939 2.427 1.81a43.883 43.883 0 006.633 3.837l.3.3c.557.566 1.3 1.322 1.906 1.85.282-.247.595-.544.9-.847a43.126 43.126 0 007.359 2.028c-2.516 2.348-4.967 5.559-7.828 5.862h-.435"
        fill="#07677e"
      />
      <path
        d="M430.472 401.03a33.378 33.378 0 01-33.339-33.34 33.378 33.378 0 0133.339-33.34 33.378 33.378 0 0133.339 33.34 33.378 33.378 0 01-33.339 33.34"
        fill="#fff"
      />
      <path
        d="M430.473 331.037a36.651 36.651 0 00-36.651 36.652 36.651 36.651 0 0036.651 36.653 36.652 36.652 0 0036.651-36.653 36.652 36.652 0 00-36.651-36.652m0 6.624a30.061 30.061 0 0130.027 30.028 30.061 30.061 0 01-30.027 30.029 30.062 30.062 0 01-30.027-30.028 30.062 30.062 0 0130.027-30.029"
        fill="#07677e"
      />
      <path
        d="M437.368 396.919a43.571 43.571 0 0012.524-20.015c4.048-14.447-2.528-29.237-13.487-38.654a30.078 30.078 0 0124.093 29.44 30.083 30.083 0 01-23.13 29.229"
        fill="#fff"
      />
      <path
        d="M430.471 404.342c-1 0-1.985-.054-2.968-.131a55.121 55.121 0 009.864-7.292 30.083 30.083 0 0023.13-29.229 30.078 30.078 0 00-24.093-29.44q-1.407-1.21-2.908-2.3a87.406 87.406 0 00-7.182-4.673 37.188 37.188 0 014.157-.242 36.652 36.652 0 0136.651 36.652 36.652 36.652 0 01-36.651 36.653M304.546 301.763h79c4.6 0 4.6-7.128 0-7.128h-79c-4.6 0-4.6 7.128 0 7.128M294.453 318.394h22.57c4.6 0 4.6-7.128 0-7.128h-22.57c-4.6 0-4.6 7.128 0 7.128M336.029 318.394h54.053c4.6 0 4.6-7.128 0-7.128h-54.053c-4.6 0-4.6 7.128 0 7.128M290.888 344.021h39.8c4.6 0 4.6-7.127 0-7.127h-39.8c-4.6 0-4.6 7.127 0 7.127M349.692 344.021h26.728c4.6 0 4.6-7.127 0-7.127h-26.728c-4.6 0-4.6 7.127 0 7.127M293.263 365.997h74.84c4.6 0 4.6-7.127 0-7.127h-74.84c-4.6 0-4.6 7.127 0 7.127"
        fill="#07677e"
      />
      <g data-name="Group 567" fill="#0e74b8">
        <path
          data-name="Path 778"
          d="M341.052 229.922a29.806 29.806 0 00-5.251 4.692c-.279.279-.5.615-.782.95a30.931 30.931 0 00-4.19 6.927 9.316 9.316 0 00-.447 1.117 28 28 0 00-1.788 7.821 40.74 40.74 0 00-7.485-3.742 31.631 31.631 0 012.179-7.206c.168-.391.335-.726.5-1.117a33.68 33.68 0 014.357-7.039c.279-.335.5-.67.782-1.006a36.812 36.812 0 014.751-4.581 27.275 27.275 0 017.374 3.184"
        />
        <path
          data-name="Path 779"
          d="M379.99 240.816c-.056-.447-.056-.894-.112-1.285a45.422 45.422 0 00-.67-3.966 20.093 20.093 0 00-.67-2.458c-.279-.838-.559-1.62-.838-2.458a8.914 8.914 0 00-.559-1.285 36.007 36.007 0 00-2.123-4.134q-.754-1.257-1.508-2.346a37.1 37.1 0 00-56.757-5.084 39.778 39.778 0 00-3.464 4.022c-.5.726-1.061 1.452-1.508 2.179a34.8 34.8 0 00-2.737 5.139c-.168.447-.391.838-.559 1.285-.056.168-.168.391-.223.559-.279.726-.5 1.452-.726 2.179a39.722 39.722 0 00-1.285 5.921c-.056.447-.112.838-.168 1.285a38.46 38.46 0 00-.168 3.631v1.007a8.25 8.25 0 00.056 1.173 37.5 37.5 0 001.564 8.715c.112.391.279.838.391 1.229a37.112 37.112 0 0020.949 22.232c.112.056.168.056.279.112l1.341.5 1.005.339a39.245 39.245 0 004.415 1.116c.168.056.335.056.5.112.391.056.838.168 1.229.223.112 0 .279.056.391.056h.112a8.332 8.332 0 001.173.112c.447.056.894.056 1.285.112.782.056 1.508.056 2.29.056h.838a9.89 9.89 0 001.282-.057 10.85 10.85 0 001.341-.112h.059a.708.708 0 00.335-.056 4.314 4.314 0 00.838-.112c.447-.056.838-.112 1.285-.168 1.285-.223 2.514-.5 3.743-.838.391-.112.782-.223 1.229-.335a12.565 12.565 0 001.341-.447 37.523 37.523 0 0013.966-8.771 37.242 37.242 0 0010.837-24.021c.056-.726.056-1.452.056-2.235a29.49 29.49 0 00-.056-3.128m-46.31 31.956a28.135 28.135 0 00-3.964-5.922c-.335-.391-.726-.838-1.061-1.229a30.779 30.779 0 00-7.542-5.866 31.622 31.622 0 001.9 6.815c-.67-.614-1.285-1.229-1.9-1.843a31.108 31.108 0 01-5.084-7.206c-.223-.5-.5-.95-.67-1.452a30.821 30.821 0 014.3 1.62 13.426 13.426 0 011.285.614 31.493 31.493 0 017.988 5.81c.335.335.726.726 1.061 1.117a34.171 34.171 0 012.235 2.737c.782 1.061 1.452 2.179 2.123 3.3.335.614.67 1.285 1.006 1.955-.67-.168-1.173-.279-1.676-.447m39.435-26.315a39.934 39.934 0 00-8.212 1.9 37.8 37.8 0 01.447 5.642c0 1.229-.056 2.4-.168 3.575a31.009 31.009 0 015.7-1.9 29.529 29.529 0 01-7.767 10.838 27.266 27.266 0 01-1.955 1.62 34.471 34.471 0 002.737-9.944 33.881 33.881 0 00.223-4.19 32.747 32.747 0 00-.391-5.251 35.148 35.148 0 00-2.346-8.379 32.511 32.511 0 00-7.542 3.3 29.725 29.725 0 011.843 9.217l-1.173.838a13.116 13.116 0 00-1.4 1.061c-.335.279-.67.5-.95.782a41.458 41.458 0 00-3.91-7.486l-.67-1.006a39.52 39.52 0 00-5.307-6.089 13.068 13.068 0 00-.894-.838 47.272 47.272 0 00-5.307-4.022 27.107 27.107 0 00-4.134 6.927 32.549 32.549 0 014.134 3.184c.279.279.614.559.894.838a32.288 32.288 0 015.307 6.648l.67 1.173a33.016 33.016 0 012.4 5.586v.056c.056.168.112.391.168.559a2.72 2.72 0 01.056.67 4.342 4.342 0 01-.112.894 2.835 2.835 0 01-.5 1.006 2.987 2.987 0 01-.726.726 3.436 3.436 0 01-1.955.67h-.16a3.8 3.8 0 01-1.788-.614 2.986 2.986 0 01-.726-.726 3.7 3.7 0 01-.5-1.061 4.34 4.34 0 01-.112-.894 2.292 2.292 0 01.056-.614 1.036 1.036 0 01.112-.391c.056-.112.056-.223.112-.335a27.152 27.152 0 012.4-5.53 31.483 31.483 0 00-5.307-6.815 43.736 43.736 0 00-3.464 6.368l-.5 1.173c-.335-.279-.67-.559-.95-.782a30.897 30.897 0 00-1.62-1.229c-.391-.279-.782-.559-1.173-.782a40.645 40.645 0 00-7.6-3.91c-.391-.168-.782-.279-1.173-.447a41.272 41.272 0 00-6.983-1.788c-.056-.391-.056-.838-.112-1.229 0-.5-.056-1.006-.056-1.452a26.793 26.793 0 01.391-4.748 11.553 11.553 0 01.223-1.229h1.117a29.952 29.952 0 018.153 1.056 34.471 34.471 0 014.357-7.15 40.435 40.435 0 00-10.782-1.955l.67-1.173c.335-.559.67-1.117 1.061-1.676a15.821 15.821 0 011.117-1.564 29.525 29.525 0 0114.413-.112c.5.112.95.279 1.452.391a28.607 28.607 0 017.262 3.352c.391.223.726.5 1.061.726a28.88 28.88 0 015.307 4.8 40.778 40.778 0 017.206-3.464 37.269 37.269 0 00-4.8-4.581 9.88 9.88 0 00-1.224-.889 36.051 36.051 0 00-7.321-4.082c-.559-.223-1.061-.447-1.62-.614a35.174 35.174 0 00-11.452-1.9 30.021 30.021 0 00-3.91.223c.67-.5 1.4-.95 2.067-1.4a29.781 29.781 0 0115.474-4.246 30.469 30.469 0 0115.642 4.357 21.085 21.085 0 012.179 1.452 34.151 34.151 0 00-5.363-.391 35.425 35.425 0 00-11.452 1.9 39.015 39.015 0 017.206 4.3 28.874 28.874 0 016.648-.782 28.586 28.586 0 019.553 1.62c.391.559.782 1.117 1.173 1.732.168.279.335.5.5.782l.67 1.173a38.891 38.891 0 00-12.011 1.9c-.391.112-.782.279-1.229.391a40.564 40.564 0 00-7.206 3.408c-.335.223-.67.391-1.006.614a38.941 38.941 0 00-5.139 3.91 42.323 42.323 0 015.307 6.089 35.729 35.729 0 013.966-3.072l1.006-.67a32.1 32.1 0 017.486-3.3l1.173-.335a30.872 30.872 0 017.933-1.006c.894 0 1.732.056 2.626.112.056.391.168.782.223 1.229a31.791 31.791 0 01.335 4.637 19.922 19.922 0 01-.056 2.626"
        />
      </g>
    </g>
  </svg>
</template>
